import { Button, Card, CardContent, Typography } from "@mui/material";
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import { useState } from "react";
import i18next from "i18next";
import imgurl from "../assests/images/imgurl";
import { useSelector } from "react-redux";

const ReportContentMaster = ({keyName}) => {

  const locale = useSelector((state) => state.language.langData);

  const [masterJsonEn] = useState({
    male_photos_description_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show</h3>
          </div>
          <Typography className="description">
            Your photos reveal a full and intact hairline with no visible thinning at the crown or temples. At this stage, hair density appears normal, and there are no obvious signs of loss.
          </Typography>
          <Typography className="description mt-10px">
            You are probably worried about excessive hair loss if you are taking this test. It is normal to lose 100 hairs per day, but more shedding often marks the early phase of androgenetic alopecia, where microscopic changes may already be happening even though they are not yet visible. Starting preventive care now can help preserve natural density and delay future progression.
          </Typography>
          {/* <Typography className="description mt-10px">
            Starting preventive care now can help preserve natural density and delay future progression.
          </Typography> */}
        </CardContent>
      </Card>
    ),
    male_why_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens </h3>
          </div>
          <Typography className="description">
            Even though the scalp looks normal at stage 1, the biological process of androgenetic alopecia may already be starting below the surface. 
          </Typography>
          <ul>
            <li>
              After puberty, testosterone levels rise. About 10% of that testosterone is converted into DHT by two enzymes: 5-alpha-reductase type I and II. 
            </li>
            <li>
              In sensitive individuals, DHT binds to receptors in the hair follicles and causes them to shrink gradually.
            </li>
            <li>
              This leads to thinner, weaker hair strands, a shortened growth phase, and more follicles entering a resting phase — resulting in increased shedding and slower regrowth. 
            </li>
            <li>
              Over time, some follicles may become inactive, losing the ability to produce hair altogether. 
            </li>
          </ul>
          <Typography className="description">
            If untreated, this process progresses silently until it becomes noticeable at stages 2 and 3. Stage 1 is therefore the ideal window for prevention, as early intervention can protect follicles long before visible thinning occurs. 
          </Typography>
        </CardContent>
      </Card>
    ),
    male_what_stage1 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <ul>
          <li>Preventive medical treatment may be recommended if you have a family history of hair loss or if microscopic thinning is already detected.</li>
          <li>Lifestyle optimisation is critical at this stage to support follicle health and delay visible loss.</li>
          <li>Patients who begin preventive treatment at stage 1 often maintain natural density for years, reducing the likelihood of progression.</li>
        </ul>
        {/* <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography> */}
      </>
    ),
    male_timeline_stage1 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with preventive care</h3>
          </div>
          <ul>
            <li>
              Month 1: Density maintained. 
            </li>
            <li>
              Months 3–6: No visible changes; subtle improvements in follicle strength possible.
            </li>
            <li>
              Months 6–12: Long-term monitoring ensures that any early changes are detected and treated quickly.
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    male_lifestyle_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
          </div>
          <Typography className="description"> At this early stage, supportive care can suffice to keep follicles resilient. It consists of appropriate nutrition and scalp care.</Typography>
          <ul>
            <li>Nutrition</li>
            <Typography className="description"> A proper nutrition, rich in proteins (hair is mostly made of one important protein, keratin) is required. There are vitamins and micronutrients that are essential:</Typography>
            <ul>
              <li>Biotin — egg yolks, peanuts, almonds, sweet potatoes</li>
              <li>Zinc — chickpeas, cashews, oysters, lentils </li>
              <li>Iron — also present in lentils and chickpeas, as well as shellfish and meat </li>
              <li>Vitamin D and E — essential for follicle metabolism </li>
            </ul>
          </ul>
          <ul>
            <li> Scalp care</li>
            <Typography className="description">You must take good care of your scalp and avoid trauma of all kinds. </Typography>
            <ul>
              <li>Gentle daily massage with a silicone massager (available on this site) will improve circulation and follicle health. </li>
              <li>Avoid dyeing your hair with harsh chemicals, do not use hot dryers, and avoid hairstyles that pull strongly on your hair. </li>
              <li>Use a shampoo based on natural products that have mild anti-DHT activity — ayurvedic (bhringraj oil, amla oil) or essential oils such as saw palmetto, tea tree, rosemary, or pumpkin seed. </li>
            </ul>
          </ul>
          <ul>
            <li>Lifestyle</li>
            <ul>
              <li>Avoid smoking, as it accelerates hair thinning.</li>
              <li>Ensure sufficient sleep.</li>
              <li>Track progress: Upload scalp photos every 6–12 months. This builds a clear record to identify changes over time. </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    male_legal_stage1 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show</h3>
          </div>
          <Typography className="description">
            Your photos reveal a slight recession of the hairline at the temples, while the crown and mid-scalp remain intact. This corresponds to the early visible phase of androgenetic alopecia, where the first changes in the Norwood scale begin to appear. 
          </Typography>
          <Typography className="description mt-10px">
            Stage 2 is often subtle — many patients don’t notice the change themselves until they compare older photos. Density across most of the scalp remains good, but the temple recession is the first clinical marker of progressive hair loss. 
          </Typography>
          {/* <Typography className="description mt-10px">
            Beginning treatment now can stabilize the hairline and restore fullness within 3–6 months.
          </Typography> */}
        </CardContent>
      </Card>
    ),
    male_why_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens</h3>
          </div>
          <Typography className="description">
            In many cases, hair loss is driven by genetic sensitivity to a hormone called DHT (dihydrotestosterone). If male relatives in your family have experienced balding, your hair follicles may be more vulnerable to this hormone.
          </Typography>
          <ul>
            <li>
              After puberty, testosterone levels rise. About 10% of that testosterone is converted into DHT by two enzymes: 5-alpha-reductase type I and II. 
            </li>
            <li>
              In sensitive individuals, DHT binds to receptors in the hair follicles and causes them to shrink gradually. 
            </li>
            <li>
              This leads to thinner, weaker hair strands, a shortened growth phase, and more follicles entering a resting phase — resulting in increased shedding and slower regrowth.
            </li>
            <li>
              Over time, some follicles may become inactive, losing the ability to produce hair altogether.  
            </li>
            <li>
              Some areas of the scalp have more receptors to DHT than others, notably on the temples. This is why alopecia generally starts at that level. 
            </li>
          </ul>
          <Typography className="description mt-10px">
            At stage 2 only a small proportion of follicles are visibly affected, but the biological process is active and progressing. If untreated, this process progresses silently until it becomes noticeable at stages 3. 
          </Typography>
          <Typography className="description mt-10px">
            Stage 2 is therefore an ideal moment to act — early intervention can protect follicles long before visible thinning occurs.
          </Typography>
        </CardContent>
      </Card>
    ),
    male_what_stage2 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <ul>
          <li>Preventive medical treatment may be recommended — a doctor can assess you and, if appropriate, prescribe a clinically proven DHT-blocking therapy.</li>
          <li>Combining a DHT blocker with targeted peptides and supportive therapies can strengthen existing follicles and improve shaft thickness.</li>
          <li>Lifestyle optimisation (sleep, stress management, smoking cessation, balanced nutrition) is critical to support follicle health.</li>
          <li>Patients who begin treatment at this stage often see stabilisation and visible restoration of fullness within months. </li>
        </ul>
        <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography>
      </>
    ),
    male_timeline_stage2 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1: Hair loss begins to stabilize; shedding may decrease.   
            </li>
            <li>
              Months 3–6: Follicles in the temple region begin producing stronger, thicker hairs.  
            </li>
            <li>
              Months 6–12: Visible restoration of the hairline contour and improved density.  
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    male_lifestyle_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
          </div>
          <Typography className="description">
            At this early stage, supportive care can suffice to keep follicles resilient. It consists of appropriate nutrition and scalp care. 
          </Typography>
          <ul>
            <li>Nutrition</li>
            <Typography className="description">
              A proper nutrition, rich in proteins (hair is mostly made of one important protein, keratin) is required. There are vitamins and micronutrients that are essential: 
            </Typography>
            <ul>
              <li>Biotin — present in egg yolks, peanuts, almonds, sweet potatoes</li>
              <li>Zinc — which is found in chickpeas, cashews, oysters, lentils </li>
              <li>Iron — also present in lentils and chickpeas, as well as shellfish and meat</li>
              <li>Vitamin D and A — essential for follicle metabolism </li>
            </ul>
          </ul>
          <ul>
            <li>Scalp care</li>
            <Typography className="description">
              You must take good care of your scalp and avoid trauma of all kinds.
            </Typography>
            <ul>
              <li>
                Gentle daily massage with a silicone massager (available on this site) will improve circulation and follicle health. 
              </li>
              <li>
                Avoid dyeing your hair with harsh chemicals, do not use hot dryers, and avoid hairstyles that pull strongly on your hair.
              </li>
              <li>
                Use a shampoo based on natural products that have mild anti-DHT activity — ayurvedic (bhringraj oil, amla oil) or essential oils such as saw palmetto, tea tree, rosemary, or pumpkin seed.
              </li>
            </ul>
          </ul>
          <ul>
            <li>Lifestyle</li>
            <ul>
              <li>Avoid smoking, as it accelerates hair thinning.</li>
              <li>Ensure sufficient sleep.</li>
              <li>Track progress: Upload scalp photos every 6–12 months. This builds a clear record to identify changes over time. </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    male_legal_stage2 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show</h3>
          </div>
          <Typography className="description">
            Your photos reveal a noticeable recession of the hairline at the temples — a classic sign of androgenetic alopecia (pattern hair loss). This stage often marks the beginning of a predictable progression: the hairline continues to recede, and thinning may start to appear at the crown (vertex).
          </Typography>
          <Typography className="description mt-10px">
            This is a critical moment. Starting treatment now can help you preserve existing hair, stimulate regrowth, and slow further progression before it becomes more difficult to manage. 
          </Typography>
          {/* <Typography className="description mt-10px">
            Men at this stage often regain visible thickness within 3–6 months when treatment is started early.
          </Typography> */}
        </CardContent>
      </Card>
    ),
    male_why_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens</h3>
          </div>
          <Typography className="description">
            In many cases, hair loss is driven by genetic sensitivity to a hormone called DHT (dihydrotestosterone). If male relatives in your family have experienced balding, your hair follicles may be more vulnerable to this hormone.  
          </Typography>
          <ul>
            <li>
              After puberty, testosterone levels rise. About 10% of that testosterone is converted into DHT by two enzymes: 5-alpha-reductase type I and II.
            </li>
            <li>
              In sensitive individuals, DHT binds to receptors in the hair follicles and causes them to shrink gradually. 
            </li>
            <li>
              This leads to thinner, weaker hair strands, a shortened growth phase, and more follicles entering a resting phase — resulting in increased shedding and slower regrowth.  
            </li>
            <li>
              Over time, some follicles may become inactive, losing the ability to produce hair altogether. 
            </li>
            <li>
              Some areas of the scalp have more receptors to DHT than others, notably on the temples. This is why alopecia generally starts at that level 
            </li>
          </ul>
          <Typography className="description">
            At stage 3, the temples are highly sensitive to DHT. Visible hairline recession shows that miniaturisation is already well under way — but intervention at this point can still preserve most follicles and restore thickness. 
          </Typography>
        </CardContent>
      </Card>
    ),
    male_what_stage3 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        {/* <Typography className="description">
          You should begin a clinically proven, doctor-prescribed DHT-blocking treatment, often combined with targeted peptides. These therapies:
        </Typography> */}
        <ul>
          <li>Begin a doctor-prescribed DHT-blocking treatment. These therapies reduce the action of DHT and protect vulnerable follicles.</li>
          <li>Peptides and supportive treatments can be combined to stimulate regrowth and improve density. </li>
          <li>Patients who act at this stage often see stabilisation and visible regrowth within 3–6 months.</li>
        </ul>
        <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography>
        {/* <Typography className="description">
          A licensed doctor will review your case, confirm the stage, and prescribe the most effective treatment plan.
        </Typography> */}
      </>
    ),
    male_timeline_stage3 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment</h3>
          </div>
          <ul>
            <li>
              Month 1: Hair loss begins to stabilize; shedding may decrease. 
            </li>
            <li>
              Months 3–6: Follicles in the temple region begin producing stronger, thicker hairs.
            </li>
            <li>
              Months 6–12: Visible restoration of the hairline contour and improved density. 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    male_lifestyle_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
          </div>
          <Typography className="description"> 
            At this early stage, supportive care can suffice to keep follicles resilient. It consists of appropriate nutrition and scalp care. 
          </Typography>
          <ul>
            <li>Nutrition</li>
            <Typography className="description"> 
              A proper nutrition, rich in proteins (hair is mostly made of one important protein, keratin) is required. There are vitamins and micronutrients that are essential: 
            </Typography>
            <ul>
              <li>Biotin — present in egg yolks, peanuts, almonds, sweet potatoes</li>
              <li>Zinc — which is found in chickpeas, cashews, oysters, lentils</li>
              <li>Iron — also present in lentils and chickpeas, as well as shellfish and meat</li>
              <li>Vitamin D and A — essential for follicle metabolism</li>
            </ul>
          </ul>
          <ul>
            <li>Scalp care</li>
            <Typography className="description"> 
              You must take good care of your scalp and avoid trauma of all kinds. 
            </Typography>
            <ul>
              <li>Gentle daily massage with a silicone massager (available on this site) will improve circulation and follicle health.</li>
              <li>Avoid dyeing your hair with harsh chemicals, do not use hot dryers, and avoid hairstyles that pull strongly on your hair.</li>
              <li>Use a shampoo based on natural products that have mild anti-DHT activity — ayurvedic (bhringraj oil, amla oil) or essential oils such as saw palmetto, tea tree, rosemary, or pumpkin seed. </li>
            </ul>
          </ul>
          <ul>
            <li>Lifestyle</li>
            <ul>
              <li>Avoid smoking, as it accelerates hair thinning.</li>
              <li>Ensure sufficient sleep.</li>
              <li> Track progress: Upload scalp photos every 6–12 months. This builds a clear record to identify changes over time. </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    male_legal_stage3 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show</h3>
          </div>
          <Typography className="description">
            Your photos indicate that androgenetic alopecia has reached a more advanced stage. Visible thinning is present at the crown (vertex), combined with continued hairline recession at the temples. Without intervention, these regions often expand and begin to merge.
          </Typography>
          <Typography className="description mt-10px">
            This is an important turning point. Acting now can protect remaining follicles, restore visible density, and prevent progression into later stages. 
          </Typography>
          {/* <Typography className="description mt-10px">
            Acting now can protect remaining follicles, restore visible density, and prevent progression into advanced stages.
          </Typography> */}
        </CardContent>
      </Card>
    ),
    male_why_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens</h3>
          </div>
          <Typography className="description">
            The progression of hair loss is primarily caused by genetic sensitivity to DHT (dihydrotestosterone). 
          </Typography>
          <ul>
            <li>
              After puberty, testosterone levels rise. About 10% is converted into DHT by 5-alpha-reductase type I and II. 
            </li>
            <li>
              DHT binds to receptors in the hair follicles, causing them to shrink, weaken, and eventually become inactive. 
            </li>
            <li>
              The temples and crown are especially sensitive to DHT, which is why these areas are often the first to show signs of hair loss. 
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_what_stage4 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <ul>
          <li>
            A clinically proven, doctor-prescribed DHT blocker is essential at this stage to slow progression. 
          </li>
          <li>Specific peptides may be added to stimulate follicle activity, increase shaft thickness, and support regrowth.</li>
          <li>Patients who begin treatment at stage 4 often experience stabilisation of hair loss and visible improvement in temple and crown regions. </li>
          {/* <li>Without medical treatment, progression to Stage 5 and beyond is highly likely. </li> */}
        </ul>
        <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography>
      </>
    ),
    male_timeline_stage4 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1: Hair loss begins to stabilize; shedding may decrease. 
            </li>
            <li>
              Months 3–6: Follicles in the temple region begin producing stronger, thicker hairs. 
            </li>
            <li>
              Months 6–12: Visible restoration of the hairline contour and improved density. 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    male_lifestyle_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
          </div>
          <Typography className="description"> At this early stage, supportive care can suffice to keep follicles resilient. It consists of appropriate nutrition and scalp care.</Typography>
          <ul>
            <li>Nutrition</li>
            <Typography className="description">A proper nutrition, rich in proteins (hair is mostly made of one important protein, keratin) is required. There are vitamins and micronutrients that are essential:</Typography>
            <ul>
              <li>Biotin — present in egg yolks, peanuts, almonds, sweet potatoes </li>
              <li>Zinc — which is found in chickpeas, cashews, oysters, lentils</li>
              <li>Iron — also present in lentils and chickpeas, as well as shellfish and meat</li>
              <li>Vitamin D and A — essential for follicle metabolism </li>
            </ul>
          </ul>
          <ul>
            <li>Scalp care</li>
            <Typography className="description">You must take good care of your scalp and avoid trauma of all kinds.</Typography>
            <ul>
              <li>Gentle daily massage with a silicone massager (available on this site) will improve circulation and follicle health. </li>
              <li>Avoid dyeing your hair with harsh chemicals, do not use hot dryers, and avoid hairstyles that pull strongly on your hair.</li>
              <li>Use a shampoo based on natural products that have mild anti-DHT activity — ayurvedic (bhringraj oil, amla oil) or essential oils such as saw palmetto, tea tree, rosemary, or pumpkin seed.</li>
            </ul>
          </ul>
          <ul>
            <li>Lifestyle</li>
            <ul>
              <li>Avoid smoking, as it accelerates hair thinning.</li>
              <li>Ensure sufficient sleep.</li>
              <li>Track progress: Upload scalp photos every 6–12 months. This builds a clear record to identify changes over time.</li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    male_legal_stage4 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage5 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show</h3>
          </div>
          <Typography className="description">
            Your photos show advanced hair loss with significant temple recession and clear thinning at the crown. At this stage, the balding areas are beginning to merge, leaving only a narrowing band of hair in between.
          </Typography>
          <Typography className="description mt-10px">
            Stage 5 is a serious progression, but it is not a point of no return. With proper medical intervention, responsive follicles can still be preserved, and visible density can often be restored.
          </Typography>
          {/* <Typography className="description mt-10px">
            Stage 5 indicates that androgenetic alopecia is progressing rapidly. The central forelock may provide partial coverage but is weak and at risk of being lost without treatment.
          </Typography>
          <Typography className="description mt-10px">
            Immediate treatment is critical. With proper care, responsive follicles can be preserved, though some areas may require transplant for coverage.
          </Typography> */}
        </CardContent>
      </Card>
    ),
    male_why_stage5 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens</h3>
          </div>
          <Typography className="description">
            Hair loss at this stage is primarily caused by DHT (dihydrotestosterone), a potent hormone derived from testosterone. DHT is produced through the action of enzymes called 5-alpha-reductase.
          </Typography>
          <Typography className="description mt-10px">
            Here’s what’s happening:
          </Typography>
          <ul>
            <li>
              After puberty, testosterone levels rise. About 10% is converted into DHT by 5-alpha-reductase type I and II. 
            </li>
            <li>
              DHT binds to receptors in the hair follicles, causing them to shrink, weaken, and eventually become inactive.
            </li>
            <li>
              The temples and crown are especially sensitive to DHT, which is why these areas are often the first to show signs of hair loss  
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_what_stage5 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <ul>
          <li>Immediate prescription therapy is required — a DHT blocker remains the cornerstone of treatment.</li>
          <li>Peptides and supportive therapies can help improve the thickness and quality of remaining hair.</li>
          <li>In some cases, a hair transplant may also be considered, particularly for areas bald for a long time. </li>
        </ul>
        <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography>
      </>
    ),
    male_timeline_stage5 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1: Hair loss begins to stabilize; shedding may decrease. 
            </li>
            <li>
              Months 3–6: Follicles in the temple region begin producing stronger, thicker hairs.  
            </li>
            <li>
              Months 6–12: Visible restoration of the hairline contour and improved density.  
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    male_lifestyle_stage5 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
          </div>
          <Typography className="description">
            At this early stage, supportive care can suffice to keep follicles resilient. It consists of appropriate nutrition and scalp care.
          </Typography>
          <ul>
            <li>Nutrition</li>
            <Typography className="description">
              A proper nutrition, rich in proteins (hair is mostly made of one important protein, keratin) is required. There are vitamins and micronutrients that are essential: 
            </Typography>
            <ul>
              <li>Biotin — present in egg yolks, peanuts, almonds, sweet potatoes</li>
              <li>Zinc — which is found in chickpeas, cashews, oysters, lentils </li>
              <li>Iron — also present in lentils and chickpeas, as well as shellfish and meat </li>
              <li>Vitamin D and A — essential for follicle metabolism </li>
            </ul>
          </ul>
          <ul>
            <li>Scalp care</li>
            <Typography className="description">
              You must take good care of your scalp and avoid trauma of all kinds.
            </Typography>
            <ul>
              <li>Gentle daily massage with a silicone massager (available on this site) will improve circulation and follicle health.</li>
              <li>Avoid dyeing your hair with harsh chemicals, do not use hot dryers, and avoid hairstyles that pull strongly on your hair.</li>
              <li>Use a shampoo based on natural products that have mild anti-DHT activity — ayurvedic (bhringraj oil, amla oil) or essential oils such as saw palmetto, tea tree, rosemary, or pumpkin seed. </li>
            </ul>
          </ul>
          <ul>
            <li>Lifestyle</li>
            <ul>
              <li>Avoid smoking, as it accelerates hair thinning.</li>
              <li>Ensure sufficient sleep.</li>
              <li>Track progress: Upload scalp photos every 6–12 months. This builds a clear record to identify changes over time.</li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    male_legal_stage5 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage6 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show</h3>
          </div>
          <Typography className="description">
            Your photos reveal extensive balding across the top of the scalp, with the hairline recession and crown thinning now fully merged. Only sparse, fragile strands remain through the mid-scalp, and they no longer provide cosmetic coverage.  
          </Typography>
          <Typography className="description mt-10px">
            At this stage, your androgenetic alopecia has progressed to the point where medical treatments alone may offer only limited results. In areas where hair is already absent, the follicles have likely undergone irreversible changes and may no longer respond to therapies that target 5-alpha-reductase enzymes, which are responsible for producing DHT (dihydrotestosterone).  
          </Typography>
          <Typography className="description mt-10px">
            However, clinical studies have shown that advanced medical treatments can still improve hair density in regions where some follicles remain active — even in men at this stage of hair loss. 
          </Typography>
        </CardContent>
      </Card>
    ),
    male_why_stage6 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens</h3>
          </div>
          <Typography className="description">
            The biology of hair loss at Stage 6 is driven by the long-term destructive effect of DHT (dihydrotestosterone) on genetically sensitive follicles.  
          </Typography>
          <ul>
            <li>
              From puberty onward, about 10% of testosterone is converted into DHT by the enzymes 5-alpha-reductase type I and II. </li>
            <li>
              In individuals with androgenetic alopecia, DHT binds to receptors in follicles across the crown, mid-scalp, and frontal hairline. 
            </li>
            <li>
              This binding disrupts follicle activity in several ways: 
              <ul>
                <li>
                  The follicle shaft shrinks with each growth cycle (miniaturization).
                </li>
                <li>
                  The anagen (growth) phase shortens, so hairs don’t grow as long or thick. 
                </li>
                <li>
                  The telogen (resting) phase lengthens, leading to increased shedding.
                </li>
                <li>
                  Blood supply and nutrient delivery to the follicle are progressively reduced.
                </li>
              </ul>
            </li>
            <li>
              By Stage 6, the majority of follicles in the affected zones have been dormant for multiple cycles. These follicles are no longer capable of producing hair, even if DHT levels are suppressed.
            </li>
            <li>
              However, the donor zone at the back and sides of the scalp remains resistant to DHT and continues to grow healthy hair. These donor follicles are the foundation for hair transplantation procedures. 
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_what_stage6 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <Typography className="description">
          If your goal is to restore coverage in visibly bald areas, a hair transplant iscurrently the most effective solution. There are two primary techniques: 
        </Typography>
        <ul>
          <li>
            FUT (Follicular Unit Transplantation): A strip of scalp is removed from a donorarea, and individual follicular units are transplanted. </li>
          <li>
            FUE (Follicular Unit Extraction): Individual follicles are harvested directly fromthe donor area and implanted into the balding zones. 
          </li>
        </ul>
        <Typography className="description mt-10px">
          Both methods have their own advantages and limitations, and the choice depends on yourscalp condition, donor hair availability, and personal preferences. When performed bya skilled and experienced surgeon, success rates typically exceed 90%. 
        </Typography>
        <Typography className="description mt-10px">
          The cost of a transplant depends on the number of follicles required, and multiplesessions may be recommended to achieve optimal coverage and natural-looking results. 
        </Typography>
        <ul>
          <li>
            Peptide-based therapies can support follicle strength, scalp health, andpost-transplant recovery. 
          </li>
        </ul>
        {/* <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography> */}
      </>
    ),
    male_what_to_stage6 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">What to Expect </h3>
          </div>
          <ul>
            <li>
              After one transplant, coverage may resemble Norwood stage 3 or 4
            </li>
            <li>
              For greater density, additional sessions may be necessary 
            </li>
            <li>
              To maintain results and protect transplanted follicles, prescription DHT blockers may help protect donor follicles and ensure transplanted grafts remain healthy.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    // male_timeline_stage6 : (
    //   <Card className="statCard yourPhotossection">
    //      <CardContent className="cardContent">
    //       <div className="photoHeader">
    //         <AccessTimeOutlinedIcon className="cameraIcon" />
    //         <h3 className="photoTitle">Expected timeline with treatment </h3>
    //       </div>
    //       <ul>
    //         <li>
    //           Month 1:  density maintained. 
    //         </li>
    //         <li>
    //           Months 3–6:  No visible changes; subtle improvements in follicle strepossible.
    //         </li>
    //         <li>
    //           Months 6–12: Long-term monitoring ensures that any early changesdetected and treated quickly.
    //         </li>
    //       </ul>
    //      </CardContent>
    //   </Card>
    // ),
    // male_lifestyle_stage6 : (
    //   <Card className="statCard yourPhotossection">
    //     <CardContent className="cardContent">
    //       <div className="photoHeader">
    //         <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
    //       </div>
    //       <Typography className="description">While surgery and prescription therapy are the cornerstones, lifestyle choices remain important to support outcomes: </Typography>
    //       <ul>
    //         <li>Nutrition: </li>
    //         <ul>
    //           <li> Biotin — egg yolks, almonds, peanuts, sweet potatoes</li>
    //           <li>Zinc — lentils, cashews, chickpeas, oysters</li>
    //           <li>Vitamins A, D, and E — help strengthen scalp and follicle environment </li>
    //         </ul>
    //       </ul>
    //       <ul>
    //         <li> Scalp Stimulation:</li>
    //         <ul>
    //           <li>Gentle scalp massage with a silicone massager, 5 minutes daily, improves circulation and aids healing post-transplant.</li>
    //         </ul>
    //       </ul>
    //       <ul>
    //         <li>Avoid: Smoking, excessive alcohol, chemical styling treatments, and direct trauma to the scalp after surgery. </li>
    //       </ul>
    //       <ul>
    //         <li>Track Progress: Post-transplant regrowth begins at 3–4 months, with major density improvements by 9–12 months. Uploading photos every 3 months through the app ensures accurate tracking. </li>
    //       </ul>
    //     </CardContent>
    //   </Card>
    // ),
    male_legal_stage6 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage7 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show</h3>
          </div>
          <Typography className="description">
            Your photos reveal end-stage androgenetic alopecia. The entire top of the scalp, including the hairline, mid-scalp, and crown, is bald, with only a narrow horseshoe-shaped band of hair remaining along the back and sides.
          </Typography>
          <Typography className="description mt-10px">
            Advanced baldness requires surgical restauration of coverage
          </Typography>
          <Typography className="description mt-10px">
            You’ve reached Norwood stage 7, hair loss is extensive — but a transplant is still a viable option. At this stage, surgeons may need to harvest follicles from alternative donor sites, such as the beard, chest, or back, especially if scalp donor areas are limited.
          </Typography>
        </CardContent>
      </Card>
    ),
    // male_why_stage7 : (
    //   <Card className="statCard yourPhotossection">
    //     <CardContent className="cardContent">
    //       <div className="photoHeader">
    //         <h3 className="photoTitle"> Why This Happens</h3>
    //       </div>
    //       <Typography className="description">
    //         Stage 7 occurs because of the long-term, cumulative impact of DHT (dihydrotestosterone) on genetically sensitive follicles over many years.  
    //       </Typography>
    //       <ul>
    //         <li>From puberty onward, testosterone is partially converted into DHT by 5-alpha-reductase type I and II. </li>
    //         <li>
    //           In men with androgenetic alopecia, DHT binds strongly to receptors in follicles across the entire top of the scalp. 
    //         </li>
    //         <li>
    //           This results in repeated miniaturization cycles:
    //           <ul>
    //             <li>
    //               Hair shafts become progressively thinner and weaker. 
    //             </li>
    //             <li>
    //               The growth (anagen) phase shortens, so new hairs cannot reach full length or density. 
    //             </li>
    //             <li>
    //               The resting (telogen) phase dominates, increasing shedding and preventing replacement growth.
    //             </li>
    //           </ul>
    //         </li>
    //         <li>
    //           After multiple cycles, a large proportion of follicles become completely inactive, with no capacity to produce new hair. 
    //         </li>
    //         <li>
    //           By Stage 7, the only remaining active follicles are located in the donor zone at the back and sides, which are genetically resistant to DHT. These hairs form the basis for transplantation, but donor supply is often limited compared to the size of the bald area. 
    //         </li>
    //       </ul>
    //     </CardContent>
    //   </Card>
    // ),
    male_what_stage7 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <ul>
          <li>
            Combined transplant techniques 
            <ul>
              <li>
                FUT is often used for harvesting from the occipital region, where donor hair is typically more robust. 
              </li>
              <li>
                FUE may be combined to extract follicles from non-scalp areas, allowing for broader coverage. 
              </li>
            </ul>
          </li>
        </ul>
        <Typography className="description mt-10px">
          Transplants at this stage may require 5,000 follicles or more, making the procedure more complex and relatively costly. Pricing depends on: 
        </Typography>
        <ul>
          <li>The number of follicles transplanted </li>
          <li>The technique used </li>
          <li>The experience and reputation of the surgeon </li>
        </ul>
        {/* <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography> */}
      </>
    ),
    male_what_to_stage7 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">What to Expect</h3>
          </div>
          <ul>
            <li>
              After one transplant, coverage may resemble Norwood stage 3 or 4  
            </li>
            <li>
              For greater density, additional sessions may be necessary  
            </li>
            <li>
              To maintain results and protect transplanted follicles, prescription DHT blockers may help protect donor follicles and ensure transplanted grafts remain healthy.  
            </li>     
          </ul>
        </CardContent>
      </Card>
    ),
    // male_timeline_stage7 : (
    //   <Card className="statCard yourPhotossection">
    //      <CardContent className="cardContent">
    //       <div className="photoHeader">
    //         <AccessTimeOutlinedIcon className="cameraIcon" />
    //         <h3 className="photoTitle">Expected timeline with treatment </h3>
    //       </div>
    //       <ul>
    //         <li>
    //           Month 1:  density maintained. 
    //         </li>
    //         <li>
    //           Months 3–6:  No visible changes; subtle improvements in follicle strepossible.
    //         </li>
    //         <li>
    //           Months 6–12: Long-term monitoring ensures that any early changesdetected and treated quickly.
    //         </li>
    //       </ul>
    //      </CardContent>
    //   </Card>
    // ),
    // male_lifestyle_stage7 : (
    //   <Card className="statCard yourPhotossection">
    //     <CardContent className="cardContent">
    //       <div className="photoHeader">
    //         <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
    //       </div>
    //       <Typography className="description">Even in advanced stages, supporting scalp and donor health is valuable:</Typography>
    //       <ul>
    //         <li>Nutrition: </li>
    //         <ul>
    //           <li>Biotin — egg yolks, almonds, peanuts, sweet potatoes</li>
    //           <li>Zinc — oysters, chickpeas, lentils, cashews</li>
    //           <li>Balanced intake of vitamins A, D, and E to support scalp condition</li>
    //         </ul>
    //       </ul>
    //       <ul>
    //         <li>Scalp Care:</li>
    //         <ul>
    //           <li> 
    //             Keep the scalp moisturized and healthy to reduce dryness and irritation. 
    //           </li>
    //           <li> 
    //             Gentle massage can maintain circulation and support post-surgical recovery if transplantation is attempted. 
    //           </li>
    //         </ul>
    //       </ul>
    //       <ul>
    //         <li>Avoid: Smoking, poor diet, and harsh scalp products that can compromise donor follicle strength. </li>
    //       </ul>
    //       <ul>
    //         <li>Track Progress: Even at Stage 7, continued use of the in-app tracker ensures that scalp condition and any treatment outcomes (transplant, SMP, or systems) are monitored visually. </li>
    //       </ul>
    //     </CardContent>
    //   </Card>
    // ),
    male_legal_stage7 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 
            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    female_photos_description_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show</h3>
          </div>
          <Typography className="description">
            Your photos reveal no visible thinning. Hair appears full and dense, with the central parting remaining narrow and the scalp well covered. 
          </Typography>
          <Typography className="description mt-10px">
            You probably chose to take this test because of increased shedding or a change in styling volume, even though thinning is not yet visible. These concerns are important, as they may represent the earliest signals of change. 
          </Typography>
          <Typography className="description mt-10px">
            Women at this stage who begin preventive care are more likely to maintain full density and delay the onset of visible thinning. 
          </Typography>
        </CardContent>
      </Card>
    ),
    female_why_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens</h3>
          </div>
          <Typography className="description">
            Losing up to 100 hairs per day is normal and should not be a cause for alarm. However, in women with a genetic predisposition, the balance of hormones and follicle sensitivity can gradually change.  
          </Typography>
          <ul>
            <li>
              If close relatives experienced thinning, your risk may be higher. 
            </li>
            <li>
              Oestrogen normally protects the follicles by prolonging the growth phase of the cycle and helping to maintain density. 
            </li>
            <li>
              After menopause, declining oestrogen levels reduce this protection, and follicles become more vulnerable. 
            </li>
            <li>
              Some of the androgens your body produces get converted into dihydrotestosterone (DHT).  
            </li>
            <li>
              In sensitive follicles, DHT binds to receptors and triggers miniaturisation: hairs grow back finer, the active growth phase shortens, and resting phases lengthen. 
            </li>
            <li>
              This process can progress into visible thinning — most often along the central parting and crown, which defines the Sinclair pattern of female hair loss. 
            </li>
          </ul>
          <Typography className="description">
            At stage 1, your coverage is still good. But understanding these mechanisms explains why early vigilance or preventive treatment is often recommended, especially if there is family history. 
          </Typography>
        </CardContent>
      </Card>
    ),
    female_what_stage1 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <ul>
          <li>Preventive prescription care may be recommended to protect follicles before visible thinning begins. </li>
          <li>Monitoring is also an option — if you prefer to wait, we recommend repeating the test in 6 months. </li>
          <li>
            A doctor’s evaluation can help you decide if preventive therapy is right for you.
          </li>
        </ul>
        <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography>
      </>
    ),
    female_timeline_stage1 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with preventive care  </h3>
          </div>
          <ul>
            <li>
              Month 1–2: Shedding may stabilise with application of a preventive lotion. 
            </li>
            <li>
              Month 3–6: Subtle thickening possible. 
            </li>
            <li>
              Month 6+: Maintenance of density and delayed onset of thinning. 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    female_lifestyle_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
          </div>
          <Typography className="description">
            Hair health is also highly dependent on the way you eat and take care of your scalp. 
          </Typography>
          <ul>
            <li>Nutrition</li>
            <Typography className="description">
              A proper nutrition, rich in proteins (hair is mostly made of one important protein, keratin) is required.  There are vitamins and micronutrients that are essential:  
            </Typography>
            <ul>
              <li>Biotin — present in egg yolks, peanuts, almonds, sweet potatoes </li>
              <li>Zinc —  which is found in chickpeas, cashews, oysters, lentils </li>
              <li>Iron – also present in lentils and chickpeas, as well as shellfish and meat.</li>
              <li>Vitamin D and A — are essential for follicle metabolism present in oily fish, dairy and eggs </li>
              <li>Also include fruits, vegetables, and protein-rich foods to maintain overall balance. </li>
            </ul>
          </ul>
          <ul>
            <li>Scalp care </li>
            <ul>
              <li>Use sulphate-free shampoos. Rosemary or lavender extracts may provide mild anti-DHT support.</li>
              <li>
                Massage the scalp gently with a silicone massager to improve blood circulation. 
              </li>
              <li>Avoid harsh dyes, frequent bleaching, and heat styling.</li>
            </ul>
          </ul>
          <ul>
            <li>Wellness</li>
            <ul>
              <li>Prioritise sufficient sleep and stress management (yoga, meditation, deep breathing). </li>
              <li>Avoid smoking, which reduces blood flow and accelerates hair loss. </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    female_legal_stage1 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 
            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    female_photos_description_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show</h3>
          </div>
          <Typography className="description">
            Your photos reveal mild widening of the central parting, with a slight reduction in density compared to stage 1. Hair remains overall full, but subtle changes in volume may be noticeable when styling.
          </Typography>
          <Typography className="description mt-10px">
            This corresponds to stage 2 on the Sinclair scale, considered the early visible stage of female pattern hair loss. You probably chose to take the test because of increased shedding or noticing more scalp visibility under bright light
          </Typography>
          <Typography className="description mt-10px">
            Women who begin treatment at stage 2 often stabilise shedding quickly and preserve density over the long term.
          </Typography>
        </CardContent>
      </Card>
    ),
    female_why_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens</h3>
          </div>
          <Typography className="description">
            At stage 2, the first visible signs of follicle miniaturisation appear. 
          </Typography>
          <ul>
            <li>
              In addition to shedding, the regrown hairs are finer and shorter, leading to gradual loss of volume. 
            </li>
            <li>
              The central parting begins to widen as miniaturised hairs provide less coverage. 
            </li>
            <li>
              After menopause, levels of oestrogen and progestogen decline, while androgens exert a stronger influence. 
            </li>
            <li>
              Some of these androgens are converted into dihydrotestosterone (DHT), which binds to follicle receptors and triggers miniaturisation. 
            </li>
            <li>
              Sensitive follicles then produce progressively thinner hair, and coverage decreases.
            </li>
          </ul>
          <Typography className="description">
            This stage marks the shift from invisible shedding to visible thinning, making it a crucial moment to begin preventive treatment.
          </Typography>
        </CardContent>
      </Card>
    ),
    female_what_stage2 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <ul>
          <li>A doctor may find that you need a prescription of anti-androgen therapy that can block follicle sensitivity to DHT and preserve thickness.</li>
          <li>Such topical treatments may stimulate regrowth of miniaturised hairs.</li>
          <li>Regular monitoring with repeat tests every 2 months will help track stability and guide adjustments.</li>
        </ul>
        <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography>
      </>
    ),
    female_timeline_stage2 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with preventive care  </h3>
          </div>
          <ul>
            <li>
              Month 1-2: Stabilisation of shedding 
            </li>
            <li>
              Months 3-6: New regrowth begins to appear  
            </li>
            <li>
              Months 6-12: Visible thickening, improved volume, and reduction in scalp visibility
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    female_lifestyle_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
          </div>
          <Typography className="description mt-10px">
            Hair health is also highly dependent on the way you eat and take care of your scalp.
          </Typography>
          <ul>
            <li>Nutrition</li>
            <Typography className="description">
              A proper nutrition, rich in proteins (hair is mostly made of one important protein, keratin) is required.  There are vitamins and micronutrients that are essential:  
            </Typography>
            <ul>
              <li>Biotin — present in egg yolks, peanuts, almonds, sweet potatoes </li>
              <li> Zinc —  which is found in chickpeas, cashews, oysters, lentils </li>
              <li>
                Iron – also present in lentils and chickpeas, as well as shellfish and meat.
              </li>
              <li>
                Vitamin D and A — are essential for follicle metabolism present in oily fish, dairy and eggs
              </li>
              <li>
                Also include fruits, vegetables, and protein-rich foods to maintain overall balance.
              </li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Care </li>
            <ul>
              <li>Use sulphate-free shampoos. Rosemary or lavender extracts may provide mild anti-DHT support.</li>
              <li>
                Massage the scalp gently with a silicone massager to improve blood circulation. 
              </li>
              <li>Avoid harsh dyes, frequent bleaching, and heat styling. </li>
            </ul>
          </ul>
          <ul>
            <li> Wellness </li>
            <ul>
              <li>Prioritise sufficient sleep and stress management (yoga, meditation, deep breathing). </li>
              <li>
                Avoid smoking, which reduces blood flow and accelerates hair loss.  
              </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    female_legal_stage2 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 
            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary. No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    female_photos_description_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show</h3>
          </div>
          <Typography className="description">
            Your photos reveal a noticeable widening of the hair parting, with visible scalp because of thinning. Hair density in the frontal and crown regions appears reduced, even though some coverage remains. 
          </Typography>
          <Typography className="description mt-10px">
            This corresponds to Stage 3 on the Sinclair scale, where thinning becomes obvious under normal lighting conditions. Many women at this stage experience difficulty maintaining the same hairstyles. You probably face this issue, as well as experiencing reduced volume.
          </Typography>
          <Typography className="description mt-10px">
            Women at Stage 3 who start treatment often see significant improvement in density within 6–12 months. 
          </Typography>
        </CardContent>
      </Card>
    ),
    female_why_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens</h3>
          </div>
          <Typography className="description">
            At Stage 3, the process of follicle miniaturisation that has started at menopause becomes visible.
          </Typography>
          <ul>
            <li>
              Shedding has resulted in a scalp that shows clearly through the central parting, and thinning is noticeable in normal lighting. 
            </li>
            <li>
              Miniaturised hairs, typical of alopecia, are thinner and shorter, which reduces their ability to provide volume and coverage. 
            </li>
            <li>
              After menopause, the decline in oestrogen and progestogen removes much of the natural protection that previously helped maintain density. 
            </li>
            <li>
              This shift allows androgens, particularly dihydrotestosterone (DHT), to play a more prominent role, and DHT causes the miniaturisation process as well as the loss of ability of follicles to generate new quality hair.   
            </li>
            <li>
              The hair cycle becomes imbalanced: the growth phase shortens, while the resting phase lengthens, resulting in continuous shedding without full replacement.  
            </li>
            <li>
              This is a frequent and the biochemical process leading to the effect of DHT to the follicles has been thoroughly studied.  
            </li>
          </ul>
          <Typography className="description">
            At Stage 3, this process is still highly manageable with treatment — but if ignored, progression to more advanced stages becomes likely. 
          </Typography>
        </CardContent>
      </Card>
    ),
    female_what_stage3 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <ul>
          <li>A doctor may find that the prescription of topical anti-androgen therapies  can significantly slow or halt progression. </li>
          <li>Combination approaches (medical + supportive care) give the best chance of visible thickening. </li>
          <li>Follow-up testing every 2 months is recommended to track changes and adjust treatment. </li>
        </ul>
        <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography>
      </>
    ),
    female_timeline_stage3 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1-2: Stabilisation of shedding
            </li>
            <li>
              Months 3-6: New regrowth begins to appear 
            </li>
            <li>
              Months 6-12: Visible thickening, improved volume, and reduction in scalp visibility 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    female_lifestyle_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
          </div>
          <Typography className="description">
            Hair health is also highly dependent on the way you eat and take care of your scalp. 
          </Typography>
          <ul>
            <li>Nutrition</li>
            <Typography className="description">
              A proper nutrition, rich in proteins (hair is mostly made of one important protein, keratin) is required.  There are vitamins and micronutrients that are essential:   
            </Typography>
            <ul>
              <li>Biotin — present in egg yolks, peanuts, almonds, sweet potatoes </li>
              <li>Zinc —  which is found in chickpeas, cashews, oysters, lentils </li>
              <li>
                Iron – also present in lentils and chickpeas, as well as shellfish and meat.   
              </li>
              <li>
                Vitamin D and A — are essential for follicle metabolism present in oily fish, dairy and eggs 
              </li>
              <li>
                Also include fruits, vegetables, and protein-rich foods to maintain overall balance.    
              </li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Care </li>
            <ul>
              <li>Use sulphate-free shampoos; natural options with rosemary or lavender may support scalp health. </li>
              <li>Perform gentle scalp massage daily to stimulate circulation (unless using prescription topicals). </li>
              <li>Avoid harsh chemical treatments and high-heat styling. </li>
            </ul>
          </ul>
          <ul>
            <li> Wellness </li>
            <ul>
              <li>
                Ensure adequate sleep and manage stress through yoga, meditation, or relaxation.
              </li>
              <li>
                Do not smoke, as it reduces scalp blood flow and accelerates miniaturisation.  
              </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    female_legal_stage3 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    female_photos_description_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show</h3>
          </div>
          <Typography className="description">
            Your photos reveal a marked widening of the central parting, with the scalp clearly visible. The crown and mid-frontal areas show reduced density, though lateral and occipital (back) regions remain well preserved.
          </Typography>
          <Typography className="description mt-10px">
            This corresponds to stage 4 on the Sinclair scale, where thinning is significant enough to be noticed in casual settings. You probably find this stage distressing, as scalp visibility becomes difficult to mask and hairstyles no longer provide the same coverage.
          </Typography>
          <Typography className="description mt-10px">
            Women at stage 4 who commit to treatment often stabilise progression and achieve visible thickening within 6–12 months. 
          </Typography>
        </CardContent>
      </Card>
    ),
    female_why_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens</h3>
          </div>
          <Typography className="description">
            By stage 4, the process of follicle miniaturisation has advanced significantly.  
          </Typography>
          <ul>
            <li>After menopause, the oestrogens that protected the hair follicles disappear and they become sensitive to androgens, and particularly dihydro-testosterone (DHT). Not all women lose hair after menopause; only those whose follicles are genetically sensitive to DHT, which shortens the life of follicles, shrinks them and blocks hair growth.</li>
            <li>
              Miniaturised hairs dominate, producing strands that are progressively finer, weaker, and less pigmented. 
            </li>
            <li>
              The growth cycle becomes more disrupted: fewer hairs enter the anagen (growth) phase, while more shift into telogen (resting), which accelerates visible loss.   
            </li>
          </ul>
          <Typography className="description">
            At this stage, the loss of volume is substantial, and the scalp is conspicuous in most lighting conditions.  An appropriate intervention is essential to preserve the remaining density, stop further progression and regrow healthy hair. 
          </Typography>
        </CardContent>
      </Card>
    ),
    female_what_stage4 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <ul>
          <li>A medical doctor can prescribe an effective anti-DHT treatment to preserve remaining active follicles and regrow hair from those that can be revived.</li>
          <li>Anti-androgen therapies can block DHT activity and extend growth phases, but can only be recommended by a medical doctor after careful evaluation of your condition. </li>
          <li>Combination therapy — prescription + lifestyle measures — offers the best chance of visible recovery. </li>
          <li>Ongoing monitoring with repeat tests every 2 months is essential to track treatment effectiveness. </li>
        </ul>
        <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography>
      </>
    ),
    // female_timeline_stage4 : (
    //   <Card className="statCard yourPhotossection">
    //      <CardContent className="cardContent">
    //       <div className="photoHeader">
    //         <AccessTimeOutlinedIcon className="cameraIcon" />
    //         <h3 className="photoTitle">Expected timeline with treatment </h3>
    //       </div>
    //       <ul>
    //         <li>
    //           Month 1–2: Stabilisation of shedding 
    //         </li>
    //         <li>
    //           Month 3–6: Thickening of miniaturised hairs 
    //         </li>
    //         <li>
    //           Month 6–12: Visible improvement in scalp coverage and parting density 
    //         </li>
    //       </ul>
    //      </CardContent>
    //   </Card>
    // ),
    female_lifestyle_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
          </div>
          <Typography className="description">
            Hair health is also highly dependent on the way you eat and take care of your scalp. 
          </Typography>
          <ul>
            <li>Nutrition</li>
            <ul>
              <li>Biotin — present in egg yolks, peanuts, almonds, sweet potatoes </li>
              <li>Zinc —  which is found in chickpeas, cashews, oysters, lentils </li>
              <li>
                Iron – also present in lentils and chickpeas, as well as shellfish and meat. 
              </li>
              <li>
                Vitamin D and A — are essential for follicle metabolism present in oily fish, dairy and eggs 
              </li>
              <li>
                Also include fruits, vegetables, and protein-rich foods to maintain overall balance.  
              </li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Care </li>
            <ul>
              <li>
                Use sulphate-free shampoos; natural options with rosemary or lavender may support scalp health. 
              </li>
              <li>Perform gentle scalp massage daily to stimulate circulation (unless using prescription topicals). </li>
              <li>Avoid harsh chemical treatments and high-heat styling. </li>
            </ul>
          </ul>
          <ul>
            <li> Wellness </li>
            <ul>
              <li>Ensure adequate sleep and manage stress through yoga, meditation, or relaxation.  </li>
              <li>
                Do not smoke, as it reduces scalp blood flow and accelerates miniaturisation. 
              </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    female_legal_stage4 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    female_photos_description_stage5 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show</h3>
          </div>
          <Typography className="description">
            Your photos reveal severe balding, with large areas of scalp visible. The crown and mid-frontal zones are extensively affected, though the back and sides remain relatively preserved. 
          </Typography>
          <Typography className="description mt-10px">
            This corresponds to Stage 5 on the Sinclair scale, where thinning is obvious in all lighting conditions. You certainly experience loss of volume, difficulty styling, and a strong emotional impact due to the visibility of the condition. Your reaction is probably to try to hide the condition with a hat or a wig, but it is still possible to improve it markedly. 
          </Typography>
          <Typography className="description mt-10px">
            Women who begin medical treatment at Stage 5 may still achieve visible thickening, but preserving the remaining follicles is as urgent as stimulating the ones that have become dormant.
          </Typography>
        </CardContent>
      </Card>
    ),
    female_why_stage5 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens</h3>
          </div>
          <Typography className="description">
            At Stage 5, the process of miniaturisation has reached an advanced level, and the impact on coverage is significant. 
          </Typography>
          <ul>
            <li>
              After menopause, the oestrogens that protected the hair follicles disappear and they become sensitive to androgens, and particularly dihydro-testosterone (DHT). Not all women lose hair after menopause; only those whose follicles are genetically sensitive to DHT, which shortens the life of follicles, shrinks them and blocks hair growth.
            </li>
            <li>
              Miniaturised hairs dominate, producing strands that are progressively finer, weaker, and less pigmented.  
            </li>
            <li>
              The growth cycle becomes more disrupted: fewer hairs enter the anagen (growth) phase, while more shift into telogen (resting), which accelerates visible loss.  
            </li>
          </ul>
          <Typography className="description">
            This explains why Stage 5 represents a severe form of female pattern hair loss. The scalp is highly visible in nearly all lighting conditions, and spontaneous recovery is unlikely. A medical intervention is essential at this point to maintain the remaining density and prevent further irreversible progression.   
          </Typography>
        </CardContent>
      </Card>
    ),
    female_what_stage5 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <ul>
          <li> A doctor may prescribe a medical anti-DHT treatment to you.  Such prescription therapies can reduce androgen sensitivity and reactivate dormant follicles.</li>
          <li>
            If your goal is to restore coverage in visibly areas, a hair transplant is currently the most effective solution. There are two primary techniques: 
            <ul>
              <li>FUT (Follicular Unit Transplantation): A strip of scalp is removed from a donor area, and individual follicular units are transplanted. </li>
              <li>FUE (Follicular Unit Extraction): Individual follicles are harvested directly from the donor area and implanted into the balding zones. </li>
            </ul>
            Both methods have their own advantages and limitations, and the choice depends on your scalp condition, donor hair availability, and personal preferences. When performed by a skilled and experienced surgeon, success rates typically exceed 90%. The cost of a transplant depends on the number of follicles required, and multiple sessions may be recommended to achieve optimal coverage and natural-looking results.
          </li>
        </ul>
        <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography>
      </>
    ),
    female_timeline_stage5 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1-2: Stabilisation of shedding
            </li>
            <li>
              Months 3-6: Reactivation of weakened follicles, with early regrowth 
            </li>
            <li>
              Months 6-12: Visible thickening and improved scalp coverage, though full restoration may not be possible 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    female_lifestyle_stage5 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
          </div>
          <Typography className="description">
            Hair health is also highly dependent on the way you eat and take care of your scalp. 
          </Typography>
          <ul>
            <li>Nutrition</li>
            <ul>
              <Typography className="description">
                A proper nutrition, rich in proteins (hair is mostly made of one important protein, keratin) is required.  There are vitamins and micronutrients that are essential:   
              </Typography>
              <li>Biotin — present in egg yolks, peanuts, almonds, sweet potatoes </li>
              <li> Zinc —  which is found in chickpeas, cashews, oysters, lentils </li>
              <li>
                Iron – also present in lentils and chickpeas, as well as shellfish and meat. 
              </li>
              <li>
                Vitamin D and A — are essential for follicle metabolism present in oily fish, dairy and eggs 
              </li>
              <li>
                Also include fruits, vegetables, and protein-rich foods to maintain overall balance.  
              </li>
            </ul>
          </ul>
          {/* <ul>
            <li> Scalp Care </li>
            <ul>
              <li>
                Stick to sulphate-free shampoos, ideally with natural supportive ingredients. 
              </li>
              <li>Gentle scalp massage daily can improve circulation, unless contraindicated by topical therapy. </li>
              <li>Avoid frequent bleaching, dyes, or heavy heat styling. </li>
            </ul>
          </ul> */}
          <ul>
            <li> Wellness </li>
            <ul>
              <li>
                Ensure adequate sleep and manage stress through yoga, meditation, or relaxation. 
              </li>
              <li>
                Do not smoke, as it reduces scalp blood flow and accelerates miniaturisation. 
              </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    female_legal_stage5 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 
            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
  })

  const [masterJsonFr] = useState({
    male_photos_description_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show French</h3>
          </div>
          <Typography className="description">
            Your photos reveal a full and intact hairline with no visible thinning at the croortemples. At this stage, hair density appears normal, and there are no obviosigns ofloss.
          </Typography>
          <Typography className="description mt-10px">
            This stage often marks the earliest phase of androgenetic alopecia, whemicroscopicchanges may already be beginning even though they are not yet visible.
          </Typography>
          <Typography className="description mt-10px">
            Starting preventive care now can help preserve natural density and delay future progression.
          </Typography>
        </CardContent>
      </Card>
    ),
    male_why_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens</h3>
          </div>
          <Typography className="description">
            Even though the scalp looks normal at Stage 1, the  biological processandrogenetialopecia may already be starting below the surface. 
          </Typography>
          <ul>
            <li>After puberty,   testosterone levels rise, and about   10% is convertinto D(dihydrotestosterone)  by the enzymes 5-alpha-reductase type I and I</li>
            <li>
              In genetically sensitive individuals,  DHT binds to receptors in tfolliclesparticularly at the temples and crown.
            </li>
            <li>
              At first, this binding does not cause visible thinning, but microscopstudiesshothat  some follicles already begin miniaturizing — producislightly finer hairswitshorter growth cycles. 
            </li>
            <li>
              The   anagen (growth) phase begins to shorten,  and the  telogen (restinphasbeginsto lengthen,  though not yet enough to reduce visible density. 
            </li>
            <li>
              If untreated, this process progresses silently until it becomes noticeable Stage orStage 3.
            </li>
          </ul>
          <Typography className="description">
            Stage 1 is therefore the   ideal window for prevention, as early interventicaprotectfollicles long before visible thinning occurs. 
          </Typography>
        </CardContent>
      </Card>
    ),
    male_what_stage1 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <ul>
          <li>Preventive medical treatment  may be recommended if there isstronfamily historyof hair loss or if microscopic thinning is alreadetected.</li>
          <li>Lifestyle optimization  is critical at this stage to suppofolliclhealth anddelay visible loss.</li>
          <li>Patients who begin preventive treatment at Stage 1 often maintanaturadensityfor years, reducing the likelihood of progression. </li>
        </ul>
        <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography>
      </>
    ),
    male_timeline_stage1 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1:  density maintained. 
            </li>
            <li>
              Months 3–6:  No visible changes; subtle improvements in follicle strepossible.
            </li>
            <li>
              Months 6–12: Long-term monitoring ensures that any early changesdetected and treated quickly.
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    male_lifestyle_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
          </div>
          <Typography className="description"> At this early stage, supportive care ofteenough to keep follicles resilient:</Typography>
          <ul>
            <li>Nutrition: </li>
            <ul>
              <li>Biotin — egg yolks, peanuts, almonds, sweet potatoes</li>
              <li>Zinc — chickpeas, cashews, oysters, lentils </li>
              <li>Vitamin D and E — essential for follicle metabolism </li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Stimulation:</li>
            <ul>
              <li> Gentle daily massage with a silicone massager can improve circulatianfollicle health.</li>
            </ul>
          </ul>
          <ul>
            <li>Avoid: Smoking, poor sleep, stress, and harsh chemical treatments.  </li>
          </ul>
          <ul>
            <li>Track Progress: Upload scalp photos every 6–12 months using the app. Thbuilds clear record of density changes over time. </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_legal_stage1 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show</h3>
          </div>
          <Typography className="description">
            Your photos reveal a slight recession of the hairline at the temples, while the crown and mid-scalp remain intact. This corresponds to early androgenetic alopecia, where the first visible changes in the Norwood scale begin to appear. 
          </Typography>
          <Typography className="description mt-10px">
            Stage 2 is often subtle — many patients don’t notice the change themselves until they compare older photos. The density across most of the scalp remains strong, but the temple recession is the first clinical marker of progressive hair loss.
          </Typography>
          <Typography className="description mt-10px">
            Beginning treatment now can stabilize the hairline and restore fullness within 3–6 months.
          </Typography>
        </CardContent>
      </Card>
    ),
    male_why_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens</h3>
          </div>
          <Typography className="description">
            The changes seen at Stage 2 are the result of follicle miniaturization triggered by DHT (dihydrotestosterone). 
          </Typography>
          <ul>
            <li>
              After puberty, testosterone is partially converted to DHT by the enzyme 5-alpha-reductase type I and II.
            </li>
            <li>
              In individuals with genetic sensitivity, DHT binds to receptors in the hair follicles at the temples, where follicles are highly susceptible.
            </li>
            <li>
                The process of miniaturization begins:
              <ul>
                <li>
                  Hairs in these regions emerge finer, shorter, and less pigmented.
                </li>
                <li>
                  The anagen (growth) phase shortens, reducing the time each follicle spends producing hair.
                </li>
                <li>
                  The telogen (resting) phase lengthens, leading to more frequent shedding.
                </li>
              </ul>
            </li>
            <li>
              At Stage 2, only a small proportion of follicles are visibly affected, but the biological process is active and progressing. 
            </li>
            <li>
              If untreated, the temple recession deepens and usually leads into the Stage 3 pattern, where hairline loss becomes pronounced. 
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_what_stage2 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <ul>
          <li>Early intervention is key at this stage. A doctor-prescribed plan can protect vulnerable follicles before large-scale loss occurs.</li>
          <li>Prescription DHT blockers may be advised to stop further miniaturization. </li>
          <li>Peptides and supportive therapies can strengthen existing follicles, increase shaft thickness, and maintain density. </li>
          <li>Lifestyle measures remain important to reduce stress on the follicle environment.</li>
        </ul>
        <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography>
      </>
    ),
    male_timeline_stage2 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1: Hair loss begins to stabilize; shedding may decrease.  
            </li>
            <li>
              Months 3–6: Follicles in the temple region begin producing stronger, thicker hairs. 
            </li>
            <li>
              Months 6–12: Visible restoration of the hairline contour and improved density. 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    male_lifestyle_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
          </div>
          <Typography className="description">At Stage 2, the goal is to support early intervention and protect the hairline:</Typography>
          <ul>
            <li>Nutrition: </li>
            <ul>
              <li>Biotin — egg yolks, peanuts, almonds, sweet potatoes</li>
              <li>Zinc — oysters, chickpeas, cashews, lentils</li>
              <li>Vitamins D and E to protect follicle metabolism</li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Stimulation:</li>
            <ul>
              <li> Daily scalp massage with a silicone massager for 5 minutes can improve circulation.</li>
            </ul>
          </ul>
          <ul>
            <li>Avoid: Smoking, chronic stress, excessive alcohol, and harsh styling techniques.</li>
          </ul>
          <ul>
            <li>Track Progress: Upload scalp photos every 3 months. Early changes are best detected by comparison over time.</li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_legal_stage2 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show</h3>
          </div>
          <Typography className="description">
            Your photos reveal a noticeable recession of the hairline at the temples — a classic sign of androgenetic alopecia (pattern hair loss). This stage often marks the beginning of a predictable progression: the hairline continues to recede, and thinning begins to appear at the crown (vertex). 
          </Typography>
          <Typography className="description mt-10px">
            This is a critical moment. Starting treatment now can help you preserve existing hair, stimulate regrowth, and slow further progression before it becomes more difficult to manage.
          </Typography>
          <Typography className="description mt-10px">
            Men at this stage often regain visible thickness within 3–6 months when treatment is started early.
          </Typography>
        </CardContent>
      </Card>
    ),
    male_why_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens</h3>
          </div>
          <Typography className="description">
            Most male hair loss is caused by a genetic sensitivity to a hormone called dihydrotestosterone (DHT), which is a by-product of testosterone. 
          </Typography>
          <ul>
            <li>After puberty, about 10% of testosterone is naturally converted into DHT by enzymes known as 5-alpha-reductase type I and II.</li>
            <li>
              In men with androgenetic alopecia, DHT binds to receptors in the hair follicles, especially in areas such as the temples and crown.
            </li>
            <li>
              This binding sets off a process known as follicle miniaturization:
              <ul>
                <li>
                  Follicles shrink gradually, producing hairs that are progressively thinner, weaker, and shorter. 
                </li>
                <li>
                  The anagen (growth) phase of the hair cycle shortens, while the telogen (resting) phase lengthens. 
                </li>
                <li>
                  As a result, shedding increases, and regrowth slows. 
                </li>
              </ul>
            </li>
            <li>
              Over time, if this process continues unchecked, some follicles may stop producing hair altogether. 
            </li>
          </ul>
          <Typography className="description">
            This explains why Stage 3 is such an important intervention point: the temples are highly sensitive to DHT, and visible hairline recession is a clear sign that miniaturization is well underway. Acting early can still preserve most of the follicles, restore visible thickness, and prevent progression into more advanced stages.
          </Typography>
        </CardContent>
      </Card>
    ),
    male_what_stage3 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <Typography className="description">
          You should begin a clinically proven, doctor-prescribed DHT-blocking treatment, often combined with targeted peptides. These therapies:
        </Typography>
        <ul>
          <li>Help preserve hair at the temples </li>
          <li>Slow further weakening of follicles </li>
          <li>Improve density and strength of existing hair </li>
        </ul>
        <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography>
        <Typography className="description">
          A licensed doctor will review your case, confirm the stage, and prescribe the most effective treatment plan.
        </Typography>
      </>
    ),
    male_timeline_stage3 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1: Hair loss may stabilize
            </li>
            <li>
              Months 3–6: Visible regrowth often begins 
            </li>
            <li>
              Month 6+: Gradual thickening and stronger density 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    male_lifestyle_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
          </div>
          <Typography className="description"> In addition to medical treatment, your lifestyle plays a key role:</Typography>
          <ul>
            <li>Nutrition:</li>
            <ul>
              <li>Biotin (egg yolks, peanuts, almonds, sweet potatoes)</li>
              <li>Zinc (chickpeas, cashews, lentils, oysters, mussels)</li>
            </ul>
          </ul>
          <ul>
            <li>Scalp Stimulation: Use a silicone scalp massager daily (available on this site). Massage gently for 5 minutes.</li>
          </ul>
          <ul>
            <li>Avoid: Harsh styling tools, hot dryers, smoking. </li>
          </ul>
          <ul>
            <li>
              Track your progress: Use the in-app tracker to log daily care and re-test photos.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_legal_stage3 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show</h3>
          </div>
          <Typography className="description">
            Your photos reveal visible thinning at the crown (vertex) combined with clear recession at the temples. The two regions of loss are distinct but progressively expanding.
          </Typography>
          <Typography className="description mt-10px">
            Stage 4 represents a critical turning point in androgenetic alopecia. At this stage, the hairline continues to recede while thinning at the crown accelerates. Without treatment, these areas usually progress toward merging, leading to extensive baldness in later stages. 
          </Typography>
          <Typography className="description mt-10px">
            Acting now can protect remaining follicles, restore visible density, and prevent progression into advanced stages.
          </Typography>
        </CardContent>
      </Card>
    ),
    male_why_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens</h3>
          </div>
          <Typography className="description">
            The progression of hair loss is primarily caused by genetic sensitivity to dihydrotestosterone (DHT). 
          </Typography>
          <ul>
            <li>
              After puberty, about 10% of testosterone is converted into DHT by enzymes known   as 5-alpha-reductase type I and II. </li>
            <li>
              In genetically predisposed individuals, DHT binds to receptors in the hair follicles, particularly in the crown and temple regions.
            </li>
            <li>
              Over time, this binding leads to miniaturization of the follicles: they shrink gradually, producing finer, weaker, and shorter hairs.
            </li>
            <li>
              The growth phase (anagen) of the hair cycle shortens, while the resting phase (telogen) lengthens. As a result, shedding increases, regrowth slows, and the density of the scalp visibly decreases.
            </li>
            <li>
              At Stage 4, a significant number of follicles are already compromised, and some may have become inactive, unable to produce hair altogether. 
            </li>
          </ul>
          <Typography className="description">
            This is why Stage 4 requires urgent medical treatment — it is the last stage where medical therapy alone can still produce meaningful regrowth for many patients.  
          </Typography>
        </CardContent>
      </Card>
    ),
    male_what_stage4 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <ul>
          <li>A clinically proven, doctor-prescribed DHT blocker is essential at this stage to reduce the action of DHT and slow the progression of hair loss. </li>
          <li>The treatment can be enhanced with specific peptides, which help stimulate follicle activity, improve shaft thickness, and increase density. </li>
          <li>Patients who begin treatment at Stage 4 often experience stabilization of loss and visible improvement in both temple and crown regions. </li>
          <li>Without medical treatment, progression to Stage 5 and beyond is highly likely. </li>
        </ul>
        <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography>
      </>
    ),
    male_timeline_stage4 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1: Hair shedding may begin to stabilize. 
            </li>
            <li>
              Months 3–6: Early regrowth often appears at the crown and temples. 
            </li>
            <li>
              Months 6–12: Clearer improvement in density, thicker regrowth, and stabilization of the hairline. 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    male_lifestyle_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
          </div>
          <Typography className="description"> In addition to prescription treatment, supportive measures are crucial to maximize results: </Typography>
          <ul>
            <li>Nutrition: </li>
            <ul>
              <li>Biotin (egg yolks, almonds, peanuts, sweet potatoes)</li>
              <li> Zinc (oysters, chickpeas, lentils, cashews)</li>
              <li>Vitamins D and E to strengthen follicle resilience</li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Stimulation:</li>
            <ul>
              <li>Daily scalp massage with a silicone massager improves circulation and enhances follicle activity.</li>
            </ul>
          </ul>
          <ul>
            <li>Avoid: Smoking, chronic stress, harsh styling chemicals, and excessive heat from hair dryers. </li>
          </ul>
          <ul>
            <li>Track Progress: Upload scalp photos every 3 months using the app. These will be compared with your baseline results to track your journey visually. </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_legal_stage4 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage5 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show</h3>
          </div>
          <Typography className="description">
            Your photos reveal advanced hair loss with significant temple recession and crown thinning.
          </Typography>
          <Typography className="description mt-10px">
            At this stage, the balding areas are beginning to merge, leaving only a narrow strip of thinning hair separating them.
          </Typography>
          <Typography className="description mt-10px">
            Stage 5 indicates that androgenetic alopecia is progressing rapidly. The central forelock may provide partial coverage but is weak and at risk of being lost without treatment.
          </Typography>
          <Typography className="description mt-10px">
            Immediate treatment is critical. With proper care, responsive follicles can be preserved, though some areas may require transplant for coverage.
          </Typography>
        </CardContent>
      </Card>
    ),
    male_why_stage5 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens</h3>
          </div>
          <Typography className="description">
            The driving force behind your current stage of hair loss is continued exposure of your follicles to dihydrotestosterone (DHT), a by-product of testosterone.
          </Typography>
          <ul>
            <li>
              After puberty, testosterone levels rise, and about 10% of circulating testosterone is converted into DHT by the enzymes 5-alpha-reductase type I and II. </li>
            <li>
              In individuals who are genetically sensitive, DHT binds strongly to specific receptors in the scalp follicles, especially in the temple and crown regions. 
            </li>
            <li>
              This repeated binding sets off a gradual process known as follicle miniaturization: 
              <ul>
                <li>
                  Follicles shrink in size, producing hairs that are progressively thinner,shorter, and weaker. 
                </li>
                <li>
                  The anagen (growth) phase of the hair cycle shortens, while the telogen(resting) phase lengthens. 
                </li>
                <li>
                  As a result, shedding increases, and regrowth slows dramatically.  
                </li>
              </ul>
            </li>
            <li>
              Over time, a growing percentage of follicles become inactive. In these follicles, the biological machinery required to produce new hair shuts down completely, leaving areas of scalp permanently bald.
            </li>
            <li>
              By Stage 5, this process has advanced to the point where the temples and crown thinning regions are beginning to merge, leaving large patches of scalp exposed. The central forelock may remain, but it is weakened and highly vulnerable. 
            </li>
          </ul>
          <Typography className="description">
            This is why Stage 5 is considered advanced androgenetic alopecia: while some follicles can still respond to medical therapy, many are already inactive and may only be restored through surgical options such as transplantation.  
          </Typography>
        </CardContent>
      </Card>
    ),
    male_what_stage5 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <ul>
          <li>Immediate prescription therapy is essential. </li>
          <li>A DHT blocker can still preserve the remaining responsive follicles and slow further progression. </li>
          <li>Peptides can improve the thickness and quality of hair that is still active. </li>
          <li>However, in areas where follicles are already inactive, a hair transplant may be required to restore coverage. </li>
          <li>Patients at Stage 5 benefit most from combining medical treatment with surgical planning for long-term results. </li>
        </ul>
        <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography>
      </>
    ),
    male_timeline_stage5 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1: Noticeable reduction in ongoing shedding. 
            </li>
            <li>
              Months 3–6: Visible regrowth in areas where follicles are still active. 
            </li>
            <li>
              Months 6–12: Significant thickening and reinforcement of surviving hair. 
            </li>
            <li>
              Beyond 12 months: Evaluation for transplantation in non-responsive areas.  
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    male_lifestyle_stage5 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
          </div>
          <Typography className="description"> At this stage, supportive care is especially important to protect and strengthen remaining follicles: </Typography>
          <ul>
            <li>Nutrition: </li>
            <ul>
              <li>Biotin — peanuts, almonds, eggs, sweet potatoes</li>
              <li>Zinc — chickpeas, cashews, lentils, oysters, mussels</li>
              <li>A balanced intake of vitamins A, D, and E</li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Stimulation:</li>
            <ul>
              <li>Use a silicone scalp massager for 5 minutes daily to improve circulation. </li>
            </ul>
          </ul>
          <ul>
            <li>
              Avoid: Smoking, excessive alcohol, hot styling tools, and harsh hair treatments.
            </li>
          </ul>
          <ul>
            <li>Track Progress: Continue using your app’s 3-month photo comparison tool to document improvements and guide treatment adjustments. </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_legal_stage5 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage6 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show</h3>
          </div>
          <Typography className="description">
            Your photos reveal extensive balding across the top of the scalp, with the hairline recession and crown thinning having now fully merged. Only sparse, fragile strands remain through the mid-scalp, and they no longer provide cosmetic coverage. 
          </Typography>
          <Typography className="description mt-10px">
            Stage 6 is classified as severe androgenetic alopecia. At this stage, non-surgical options alone cannot restore natural density. However, medical treatment remains important to preserve donor hair and support transplanted follicles if surgical restoration is pursued. 
          </Typography>
          <Typography className="description mt-10px">
            Surgical restoration is now the most effective option, while medical treatment supports donor health and graft survival.
          </Typography>
        </CardContent>
      </Card>
    ),
    male_why_stage6 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens</h3>
          </div>
          <Typography className="description">
            The biology of hair loss at Stage 6 is driven by the long-term destructive effect of DHT (dihydrotestosterone) on genetically sensitive follicles.  
          </Typography>
          <ul>
            <li>
              From puberty onward, about 10% of testosterone is converted into DHT by the enzymes 5-alpha-reductase type I and II. </li>
            <li>
              In individuals with androgenetic alopecia, DHT binds to receptors in follicles across the crown, mid-scalp, and frontal hairline. 
            </li>
            <li>
              This binding disrupts follicle activity in several ways: 
              <ul>
                <li>
                  The follicle shaft shrinks with each growth cycle (miniaturization).
                </li>
                <li>
                  The anagen (growth) phase shortens, so hairs don’t grow as long or thick. 
                </li>
                <li>
                  The telogen (resting) phase lengthens, leading to increased shedding.
                </li>
                <li>
                  Blood supply and nutrient delivery to the follicle are progressively reduced.
                </li>
              </ul>
            </li>
            <li>
              By Stage 6, the majority of follicles in the affected zones have been dormant for multiple cycles. These follicles are no longer capable of producing hair, even if DHT levels are suppressed.
            </li>
            <li>
              However, the donor zone at the back and sides of the scalp remains resistant to DHT and continues to grow healthy hair. These donor follicles are the foundation for hair transplantation procedures. 
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_what_stage6 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <Typography className="description">
          At Stage 6, the focus shifts from prevention alone to restoration: 
        </Typography>
        <ul>
          <li>
            Hair transplantation (FUE or FUT) is the most effective solution for restoring      visible density. 
            <ul>
              <li>FUE (Follicular Unit Extraction): Individual grafts are extracted from the donor area and implanted into balding zones.</li>
              <li>FUT (Follicular Unit Transplantation): A strip of donor scalp is removed and dissected into grafts for implantation.</li>
            </ul>
          </li>
          <li>
            Prescription DHT blockers may still be prescribed to:
            <ul>
              <li>Protect the remaining donor hair.</li>
              <li>Improve graft survival and long-term outcomes of transplantation.</li>
              <li>Prevent further weakening in partially active follicles.</li>
            </ul>
          </li>
          <li>
            Peptide-based therapies can support follicle strength, enhance scalp quality, and optimize post-transplant recovery. 
          </li>
        </ul>
        <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography>
      </>
    ),
    male_what_to_stage6 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">What to Expect With Treatment </h3>
          </div>
          <ul>
            <li>
              Without surgical intervention: Medical therapy alone cannot restore density at this stage. </li>
            <li>
              With transplantation: 
              <ul>
                <li>
                  Success rates for graft survival exceed 90% when performed by experienced surgeons.
                </li>
                <li>
                  Thousands of grafts are typically required, as restoration must cover the frontal hairline, mid-scalp, and crown. 
                </li>
                <li>
                  Multiple sessions may be recommended, depending on your donor availability and restoration goals.
                </li>
              </ul>
            </li>
            <li>
              After a transplant, ongoing medical treatment remains essential to preserve donor hair and maintain scalp health. 
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_timeline_stage6 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1:  density maintained. 
            </li>
            <li>
              Months 3–6:  No visible changes; subtle improvements in follicle strepossible.
            </li>
            <li>
              Months 6–12: Long-term monitoring ensures that any early changesdetected and treated quickly.
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    male_lifestyle_stage6 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
          </div>
          <Typography className="description">While surgery and prescription therapy are the cornerstones, lifestyle choices remain important to support outcomes: </Typography>
          <ul>
            <li>Nutrition: </li>
            <ul>
              <li> Biotin — egg yolks, almonds, peanuts, sweet potatoes</li>
              <li>Zinc — lentils, cashews, chickpeas, oysters</li>
              <li>Vitamins A, D, and E — help strengthen scalp and follicle environment </li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Stimulation:</li>
            <ul>
              <li>Gentle scalp massage with a silicone massager, 5 minutes daily, improves circulation and aids healing post-transplant.</li>
            </ul>
          </ul>
          <ul>
            <li>Avoid: Smoking, excessive alcohol, chemical styling treatments, and direct trauma to the scalp after surgery. </li>
          </ul>
          <ul>
            <li>Track Progress: Post-transplant regrowth begins at 3–4 months, with major density improvements by 9–12 months. Uploading photos every 3 months through the app ensures accurate tracking. </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_legal_stage6 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage7 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show</h3>
          </div>
          <Typography className="description">
            Your photos reveal end-stage androgenetic alopecia. The entire top of the scalp, including the hairline, mid-scalp, and crown, is bald, with only a narrow horseshoe-shaped band of hair remaining along the back and sides. 
          </Typography>
          <Typography className="description mt-10px">
            This stage represents the final progression of male pattern baldness. Natural density cannot be restored with medical therapy alone, and surgical options may be limited by donor hair availability. 
          </Typography>
          <Typography className="description mt-10px">
            Cosmetic solutions — such as strategic transplantation, scalp micropigmentation, or hair systems — can still provide visible improvement in appearance.
          </Typography>
        </CardContent>
      </Card>
    ),
    male_why_stage7 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens</h3>
          </div>
          <Typography className="description">
            Stage 7 occurs because of the long-term, cumulative impact of DHT (dihydrotestosterone) on genetically sensitive follicles over many years.  
          </Typography>
          <ul>
            <li>From puberty onward, testosterone is partially converted into DHT by 5-alpha-reductase type I and II. </li>
            <li>
              In men with androgenetic alopecia, DHT binds strongly to receptors in follicles across the entire top of the scalp. 
            </li>
            <li>
              This results in repeated miniaturization cycles:
              <ul>
                <li>
                  Hair shafts become progressively thinner and weaker. 
                </li>
                <li>
                  The growth (anagen) phase shortens, so new hairs cannot reach full length or density. 
                </li>
                <li>
                  The resting (telogen) phase dominates, increasing shedding and preventing replacement growth.
                </li>
              </ul>
            </li>
            <li>
              After multiple cycles, a large proportion of follicles become completely inactive, with no capacity to produce new hair. 
            </li>
            <li>
              By Stage 7, the only remaining active follicles are located in the donor zone at the back and sides, which are genetically resistant to DHT. These hairs form the basis for transplantation, but donor supply is often limited compared to the size of the bald area. 
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_what_stage7 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <ul>
          <li>
            Hair transplantation may still be an option, but outcomes are more limited at this stage: 
            <ul>
              <li>
                Coverage across the entire scalp is not possible due to donor shortage.
              </li>
              <li>
                A transplant may be used to reconstruct a natural-looking frontal hairline or small cosmetic zones for partial coverage. 
              </li>
            </ul>
          </li>
          <li>Prescription DHT blockers may be prescribed to protect donor follicles and ensure that any transplanted grafts remain healthy. </li>
          <li>Peptide-based scalp therapies can improve scalp condition and support long-term maintenance of transplanted follicles. </li>
          <li>For some patients, non-surgical solutions (medical-grade hair systems or scalp micropigmentation) may provide the most practical cosmetic improvement. </li>
        </ul>
        <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography>
      </>
    ),
    male_what_to_stage7 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">What to Expect With Treatment </h3>
          </div>
          <ul>
            <li>
              Without surgical or cosmetic intervention: Hair coverage will remain very limited. 
            </li>
            <li>
              With transplantation: 
              <ul>
                <li>
                  A doctor may design a conservative frontal restoration to improve appearance, using limited donor grafts. 
                </li>
                <li>
                  Full coverage is not possible, but strategic placement of grafts can improve framing of the face.
                </li>
              </ul>
            </li>
            <li>
              With non-surgical options: 
              <ul>
                <li>
                  Scalp micropigmentation can simulate the look of a closely shaved scalp. 
                </li>
                <li>
                  Hair systems can provide the appearance of full density where transplantation is not feasible. 
                </li>
              </ul>
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_timeline_stage7 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1:  density maintained. 
            </li>
            <li>
              Months 3–6:  No visible changes; subtle improvements in follicle strepossible.
            </li>
            <li>
              Months 6–12: Long-term monitoring ensures that any early changesdetected and treated quickly.
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    male_lifestyle_stage7 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
          </div>
          <Typography className="description">Even in advanced stages, supporting scalp and donor health is valuable:</Typography>
          <ul>
            <li>Nutrition: </li>
            <ul>
              <li>Biotin — egg yolks, almonds, peanuts, sweet potatoes</li>
              <li>Zinc — oysters, chickpeas, lentils, cashews</li>
              <li>Balanced intake of vitamins A, D, and E to support scalp condition</li>
            </ul>
          </ul>
          <ul>
            <li>Scalp Care:</li>
            <ul>
              <li> 
                Keep the scalp moisturized and healthy to reduce dryness and irritation. 
              </li>
              <li> 
                Gentle massage can maintain circulation and support post-surgical recovery if transplantation is attempted. 
              </li>
            </ul>
          </ul>
          <ul>
            <li>Avoid: Smoking, poor diet, and harsh scalp products that can compromise donor follicle strength. </li>
          </ul>
          <ul>
            <li>Track Progress: Even at Stage 7, continued use of the in-app tracker ensures that scalp condition and any treatment outcomes (transplant, SMP, or systems) are monitored visually. </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_legal_stage7 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    female_photos_description_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show</h3>
          </div>
          <Typography className="description">
            Your photos reveal no visible thinning. Hair appears full and dense, with the central parting remaining narrow and the scalp well covered.
          </Typography>
          <Typography className="description mt-10px">
            Some women take the test at this stage because of increased shedding or a loss of styling volume, even though thinning is not yet visible. These concerns are important, as they may represent the earliest signals of change. 
          </Typography>
          <Typography className="description mt-10px">
            Women at this stage who begin preventive care are more likely to maintain full density and delay the onset of visible thinning.
          </Typography>
        </CardContent>
      </Card>
    ),
    female_why_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens</h3>
          </div>
          <Typography className="description">
            Losing up to 100 hairs per day is normal and should not be a cause for alarm. However, in women with a genetic predisposition, the balance of hormones and follicle sensitivity can gradually change over time. 
          </Typography>
          <ul>
            <li>
              Family history plays an important role. If close female relatives experienced thinning, the risk is higher. </li>
            <li>
              Oestrogen normally protects the follicles. It prolongs the growth phase of the hair cycle and helps maintain density. 
            </li>
            <li>
              After menopause, declining oestrogen levels reduce this protection, and follicles become more vulnerable. 
            </li>
            <li>
              Even though women produce much lower levels of testosterone than men, a small fraction is converted into dihydrotestosterone (DHT).  
            </li>
            <li>
              In sensitive follicles, DHT binds to receptors and begins the process of miniaturisation: hairs grow back finer, the active growth phase shortens, and resting phases lengthen. 
            </li>
            <li>
              Over the years, this cycle can lead to progressive thinning — most often visible along the central parting and crown, which defines the Sinclair pattern of female hair loss. 
            </li>
          </ul>
          <Typography className="description">
            At Stage 1, your hair coverage is still excellent. But understanding these mechanisms explains why early vigilance or preventive treatment is often recommended, especially if there is family history.  
          </Typography>
        </CardContent>
      </Card>
    ),
    female_what_stage1 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <ul>
          <li>Preventive prescription care can help protect follicles before visible thinning begins.</li>
          <li>Monitoring is an option if you prefer to wait — we recommend repeating the test in 6 months. </li>
        </ul>
        <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography>
      </>
    ),
    female_timeline_stage1 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1–2: Shedding may stabilise
            </li>
            <li>
              Month 3–6: Subtle thickening possible 
            </li>
            <li>
              Month 6+: Maintenance of density and delayed onset of thinning 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    female_lifestyle_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
          </div>
          <ul>
            <li>Nutrition: </li>
            <ul>
              <li>Iron (spinach, lentils, red meat) </li>
              <li>Vitamin D + Calcium (oily fish, dairy, eggs) </li>
              <li>
                Biotin & Zinc (almonds, chickpeas, shellfish) 
                Also include fruits, vegetables, and protein-rich foods. 
              </li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Care </li>
            <ul>
              <li>Use sulphate-free shampoo (rosemary or lavender extracts may help).</li>
              <li>Massage the scalp gently with a silicone massager. </li>
              <li>Avoid harsh dyes, frequent bleaching, and heat styling. </li>
            </ul>
          </ul>
          <ul>
            <li> Wellness </li>
            <ul>
              <li>Prioritise sleep and manage stress (yoga, meditation, deep breathing). </li>
              <li>Avoid smoking, which reduces blood flow and accelerates hair loss. </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    female_legal_stage1 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    female_photos_description_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show</h3>
          </div>
          <Typography className="description">
            Your photos reveal mild widening of the central parting, with slightly less density visible compared to Stage 1. Hair remains overall full, but subtle changes in volume may be noticeable when styling. 
          </Typography>
          <Typography className="description mt-10px">
            This corresponds to Stage 2 on the Sinclair scale, often considered the earliest visible stage of female pattern hair loss. Many women first become aware of thinning at this point, particularly when comparing photos or noticing more scalp visibility under bright light. 
          </Typography>
          <Typography className="description mt-10px">
            Women who start medical treatment at Stage 2 often stabilise shedding quickly and preserve visible density long term.
          </Typography>
        </CardContent>
      </Card>
    ),
    female_why_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens</h3>
          </div>
          <Typography className="description">
            At Stage 2, the first visible signs of follicle miniaturisation appear. While daily shedding may still be within the normal range, the regrown hairs are no longer the same as those lost: 
          </Typography>
          <ul>
            <li>Hairs grow back finer and shorter, leading to a gradual reduction in volume.</li>
            <li>
              The central parting begins to widen as miniaturised hairs provide less coverage.
            </li>
            <li>
              After menopause, levels of oestrogen and progestogen naturally decline, while male-type hormones (androgens) may exert more influence. 
            </li>
            <li>
              If your follicles are particularly sensitive to these hormones — especially dihydrotestosterone (DHT) — this can trigger or accelerate hair loss. 
            </li>
          </ul>
          <Typography className="description">
            This stage marks the shift from invisible shedding to visible thinning, making it a crucial moment to begin preventive or corrective measures. 
          </Typography>
        </CardContent>
      </Card>
    ),
    female_what_stage2 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <ul>
          <li>Prescription anti-androgen therapy can block follicle sensitivity to DHT and preserve thickness. </li>
          <li>Topical or oral treatments may stimulate regrowth of miniaturised hairs.</li>
          <li>Regular monitoring with repeat tests every 2 months will help track stability and guide adjustments.</li>
        </ul>
        <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography>
      </>
    ),
    female_timeline_stage2 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1–2: Shedding stabilises 
            </li>
            <li>
              Month 3–6: Visible regrowth and improved density often begin 
            </li>
            <li>
              Months 6–12: Long-term monitoring ensures that any early changesdetected and treated quickly.
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    female_lifestyle_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
          </div>
          <ul>
            <li>Nutrition: </li>
            <ul>
              <li>Iron (spinach, lentils, red meat) </li>
              <li>Vitamin D + Calcium (oily fish, dairy, eggs)  </li>
              <li>
                Biotin & Zinc (almonds, chickpeas, shellfish) 
                Support with fruits, vegetables, and protein-rich foods.
              </li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Care </li>
            <ul>
              <li>Use sulphate-free shampoos; rosemary or lavender extracts may provide mild supportive benefits. </li>
              <li>Massage the scalp daily with a silicone massager to stimulate blood flow. </li>
              <li>Avoid harsh dyes, chemical treatments, or frequent heat styling. </li>
            </ul>
          </ul>
          <ul>
            <li> Wellness </li>
            <ul>
              <li>Prioritise sleep and manage stress with yoga, meditation, or relaxation techniques.</li>
              <li>
                Avoid smoking, which worsens microcirculation and accelerates miniaturisation. 
              </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    female_legal_stage2 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    female_photos_description_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show</h3>
          </div>
          <Typography className="description">
            Your photos reveal a noticeable widening of the central parting, with the scalp more visible compared to Stage 2. Hair density in the frontal and crown regions appears reduced, though overall coverage remains. 
          </Typography>
          <Typography className="description mt-10px">
            This corresponds to Stage 3 on the Sinclair scale, where thinning becomes obvious under normal lighting conditions. Many women at this stage report difficulty maintaining the same hairstyles, reduced volume, and more visible scalp in photos.
          </Typography>
          <Typography className="description mt-10px">
            Women at Stage 3 who start treatment often see significant improvement in density within 6–12 months.
          </Typography>
        </CardContent>
      </Card>
    ),
    female_why_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens</h3>
          </div>
          <Typography className="description">
            At Stage 3, the process of follicle miniaturisation becomes much more visible. 
          </Typography>
          <ul>
            <li>
              The scalp shows clearly through the central parting, and thinning is noticeable in normal lighting. 
            </li>
            <li>
              Miniaturised hairs are thinner and shorter, which reduces their ability to provide volume and coverage.
            </li>
            <li>
              After menopause, the decline in oestrogen and progestogen removes much of the natural protection that previously helped maintain density. 
            </li>
            <li>
              This shift allows androgens, particularly dihydrotestosterone (DHT), to play a more prominent role, further accelerating the miniaturisation process.  
            </li>
            <li>
              The hair cycle becomes imbalanced: the growth phase shortens, while the resting phase lengthens, resulting in continuous shedding without full replacement. 
            </li>
            <li>
              This is a widespread process: over 40% of women experience some form of alopecia after menopause, showing how common and hormonally driven this condition is. 
            </li>
          </ul>
          <Typography className="description">
            At Stage 3, the process is still highly manageable with treatment — but if ignored, progression to more advanced stages becomes likely. 
          </Typography>
        </CardContent>
      </Card>
    ),
    female_what_stage3 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <ul>
          <li>Prescription anti-androgen therapies (oral or topical) can significantly slow or halt progression. </li>
          <li>Combination approaches (medical + supportive care) give the best chance of visible thickening. </li>
          <li>Follow-up testing every 2 months is recommended to track changes and adjust treatment. </li>
        </ul>
        <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography>
      </>
    ),
    female_timeline_stage3 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1–2: Stabilisation of shedding 
            </li>
            <li>
              Month 3–6: New regrowth begins to appear 
            </li>
            <li>
              Month 6–12: Visible thickening, improved volume, and reduction in scalp visibility 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    female_lifestyle_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
          </div>
          <ul>
            <li>Nutrition: </li>
            <ul>
              <li>Iron (spinach, lentils, red meat) </li>
              <li>Vitamin D + Calcium (oily fish, dairy, eggs) </li>
              <li>
                Biotin & Zinc (almonds, chickpeas, shellfish) 
                Support with fruits, vegetables, and protein-based meals.
              </li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Care </li>
            <ul>
              <li>Use sulphate-free shampoos; natural options with rosemary or lavender may support scalp health. </li>
              <li>Perform gentle scalp massage daily to stimulate circulation (unless using prescription topicals). </li>
              <li>Avoid harsh chemical treatments and high-heat styling. </li>
            </ul>
          </ul>
          <ul>
            <li> Wellness </li>
            <ul>
              <li>Ensure adequate sleep and manage stress through yoga, meditation, or relaxation.  </li>
              <li>
                Do not smoke, as it reduces scalp blood flow and accelerates miniaturisation. 
              </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    female_legal_stage3 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    female_photos_description_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show</h3>
          </div>
          <Typography className="description">
            Your photos reveal a marked widening of the central parting, with the scalp clearly visible. Hair in the crown and mid-frontal areas shows reduced density, though lateral and occipital (back) regions remain well preserved. 
          </Typography>
          <Typography className="description mt-10px">
            This corresponds to Stage 4 on the Sinclair scale, where thinning is significant enough to be noticed in casual settings, often causing distress and changes in hairstyle to mask scalp visibility. 
          </Typography>
          <Typography className="description mt-10px">
            Women at Stage 4 who commit to medical treatment often stabilise progression and achieve visible thickening within 6–12 months.
          </Typography>
        </CardContent>
      </Card>
    ),
    female_why_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens</h3>
          </div>
          <Typography className="description">
            By Stage 4, the process of follicle miniaturisation has advanced significantly. 
          </Typography>
          <ul>
            <li>The central parting is markedly widened, and thinning now extends beyond the midline into surrounding areas of the scalp. </li>
            <li>
              Miniaturised hairs dominate, producing strands that are progressively finer, weaker, and less pigmented. 
            </li>
            <li>
              With the continued decline of oestrogen and progestogen, follicles lose their natural hormonal protection, leaving them increasingly vulnerable to androgenic influence.  
            </li>
            <li>
              Even at the lower androgen levels typical in women, DHT is sufficient to drive follicular shrinkage, leading to a progressive reduction in both hair thickness and coverage. 
            </li>
            <li>
              The growth cycle becomes more disrupted: fewer hairs enter the anagen (growth) phase, while more shift into telogen (resting), which accelerates visible loss. 
            </li>
            <li>
              By this stage, the process is part of a well-recognised pattern: more than 40% of women will develop alopecia after menopause, reflecting the loss of hormonal protection and increasing follicular vulnerability.
            </li>
          </ul>
          <Typography className="description">
            At this stage, the loss of volume is substantial, and the scalp is conspicuous in most lighting conditions. Intervention is essential to preserve the remaining density and slow further progression. 
          </Typography>
        </CardContent>
      </Card>
    ),
    female_what_stage4 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <ul>
          <li>Medical treatment is strongly recommended at this stage to preserve remaining active follicles.</li>
          <li>Anti-androgen therapies (oral or topical) help block DHT activity and extend growth phases. </li>
          <li>Combination therapy — prescription + lifestyle measures — offers the best chance of visible recovery. </li>
          <li>Ongoing monitoring with repeat tests every 2 months is essential to track treatment effectiveness. </li>
        </ul>
        <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography>
      </>
    ),
    female_timeline_stage4 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1–2: Stabilisation of shedding 
            </li>
            <li>
              Month 3–6: Thickening of miniaturised hairs 
            </li>
            <li>
              Month 6–12: Visible improvement in scalp coverage and parting density 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    female_lifestyle_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
          </div>
          <ul>
            <li>Nutrition: </li>
            <ul>
              <li>Iron (spinach, lentils, red meat) </li>
              <li>Vitamin D + Calcium (oily fish, dairy, eggs)  </li>
              <li>
                Biotin & Zinc (almonds, chickpeas, shellfish)
                Add fresh fruits, vegetables, and protein for balanced support.
              </li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Care </li>
            <ul>
              <li>
                Use sulphate-free shampoos; rosemary or lavender extracts may be beneficial. 
              </li>
              <li>Gentle daily scalp massage can support circulation. </li>
              <li>Avoid frequent bleaching, dyes, or excessive heat styling. </li>
            </ul>
          </ul>
          <ul>
            <li> Wellness </li>
            <ul>
              <li>Ensure adequate sleep and stress reduction practices (yoga, meditation).  </li>
              <li>Avoid smoking, as it impairs microcirculation and accelerates miniaturisation. </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    female_legal_stage4 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    female_photos_description_stage5 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show</h3>
          </div>
          <Typography className="description">
            Your photos reveal severe widening of the central parting, with large areas of scalp visible. The crown and mid-frontal zones are extensively affected, though the back and sides remain relatively preserved. 
          </Typography>
          <Typography className="description mt-10px">
            This corresponds to Stage 5 on the Sinclair scale, where thinning is obvious in all lighting conditions. Many women at this stage experience loss of volume, difficulty styling, and a strong emotional impact due to the visibility of the condition. 
          </Typography>
          <Typography className="description mt-10px">
            Women who begin medical treatment at Stage 5 may still achieve visible thickening, but preserving the remaining follicles is the most urgent goal.
          </Typography>
        </CardContent>
      </Card>
    ),
    female_why_stage5 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens</h3>
          </div>
          <Typography className="description">
            At Stage 5, the process of miniaturisation has reached an advanced level, and the impact on coverage is significant.
          </Typography>
          <ul>
            <li>The central parting is wide and diffuse, with thinning extending well beyond the midline into larger areas of the scalp. </li>
            <li>
              Miniaturised hairs are now the majority, producing strands that are thin, fragile, and often lack pigmentation. 
            </li>
            <li>
              The continued decline of oestrogen and progestogen after menopause removes almost all protective influence on the follicles. 
            </li>
            <li>
              In this context, even modest levels of androgens (particularly DHT) exert a strong effect, accelerating shrinkage and shortening the growth phase. 
            </li>
            <li>
              The anagen (growth) phase is progressively curtailed, while the telogen (resting) phase dominates, leading to a steady reduction in hair count and quality.
            </li>
            <li>
              By this stage, many follicles enter a prolonged dormancy, and some may cease producing visible hairs altogether. 
            </li>
          </ul>
          <Typography className="description">
            This explains why Stage 5 represents a severe form of female pattern hair loss. The scalp is highly visible in nearly all lighting conditions, and spontaneous recovery is unlikely. Medical intervention is essential at this point to maintain remaining density and prevent further irreversible progression.  
          </Typography>
        </CardContent>
      </Card>
    ),
    female_what_stage5 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <ul>
          <li>Immediate medical treatment is strongly advised. Prescription therapies can reduce androgen sensitivity and reactivate dormant follicles. </li>
          <li>Combination therapy (systemic + topical anti-androgens, plus supportive care) offers the best chance of visible improvement. </li>
          <li>Regular monitoring every 2 months is necessary to track progress and adjust treatment.</li>
        </ul>
        <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography>
      </>
    ),
    female_timeline_stage5 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1–2: Stabilisation of shedding  
            </li>
            <li>
              Month 3–6: Reactivation of weakened follicles, with early regrowth 
            </li>
            <li>
              Month 6–12: Visible thickening and improved scalp coverage, though full restoration may not be possible 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    female_lifestyle_stage5 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
          </div>
          <ul>
            <li>Nutrition: </li>
            <ul>
              <li>Iron (spinach, lentils, red meat) </li>
              <li>Vitamin D + Calcium (oily fish, dairy, eggs) </li>
              <li>
                Biotin & Zinc (almonds, chickpeas, shellfish) 
                Balanced diet with fruits, vegetables, and protein-rich foods is essential.
              </li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Care </li>
            <ul>
              <li>
                Stick to sulphate-free shampoos, ideally with natural supportive ingredients. 
              </li>
              <li>Gentle scalp massage daily can improve circulation, unless contraindicated by topical therapy. </li>
              <li>Avoid frequent bleaching, dyes, or heavy heat styling. </li>
            </ul>
          </ul>
          <ul>
            <li> Wellness </li>
            <ul>
              <li>Maintain regular sleep cycles and manage stress through meditation or yoga. </li>
              <li>Quit smoking, as it reduces blood flow and accelerates follicle loss. </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    female_legal_stage5 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
  })

  const [masterJsonEs] = useState({
    male_photos_description_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show Spanish</h3>
          </div>
          <Typography className="description">
            Your photos reveal a full and intact hairline with no visible thinning at the croortemples. At this stage, hair density appears normal, and there are no obviosigns ofloss.
          </Typography>
          <Typography className="description mt-10px">
            This stage often marks the earliest phase of androgenetic alopecia, whemicroscopicchanges may already be beginning even though they are not yet visible.
          </Typography>
          <Typography className="description mt-10px">
            Starting preventive care now can help preserve natural density and delay future progression.
          </Typography>
        </CardContent>
      </Card>
    ),
    male_why_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens</h3>
          </div>
          <Typography className="description">
            Even though the scalp looks normal at Stage 1, the  biological processandrogenetialopecia may already be starting below the surface. 
          </Typography>
          <ul>
            <li>After puberty,   testosterone levels rise, and about   10% is convertinto D(dihydrotestosterone)  by the enzymes 5-alpha-reductase type I and I</li>
            <li>
              In genetically sensitive individuals,  DHT binds to receptors in tfolliclesparticularly at the temples and crown.
            </li>
            <li>
              At first, this binding does not cause visible thinning, but microscopstudiesshothat  some follicles already begin miniaturizing — producislightly finer hairswitshorter growth cycles. 
            </li>
            <li>
              The   anagen (growth) phase begins to shorten,  and the  telogen (restinphasbeginsto lengthen,  though not yet enough to reduce visible density. 
            </li>
            <li>
              If untreated, this process progresses silently until it becomes noticeable Stage orStage 3.
            </li>
          </ul>
          <Typography className="description">
            Stage 1 is therefore the   ideal window for prevention, as early interventicaprotectfollicles long before visible thinning occurs. 
          </Typography>
        </CardContent>
      </Card>
    ),
    male_what_stage1 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <ul>
          <li>Preventive medical treatment  may be recommended if there isstronfamily historyof hair loss or if microscopic thinning is alreadetected.</li>
          <li>Lifestyle optimization  is critical at this stage to suppofolliclhealth anddelay visible loss.</li>
          <li>Patients who begin preventive treatment at Stage 1 often maintanaturadensityfor years, reducing the likelihood of progression. </li>
        </ul>
        <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography>
      </>
    ),
    male_timeline_stage1 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1:  density maintained. 
            </li>
            <li>
              Months 3–6:  No visible changes; subtle improvements in follicle strepossible.
            </li>
            <li>
              Months 6–12: Long-term monitoring ensures that any early changesdetected and treated quickly.
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    male_lifestyle_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
          </div>
          <Typography className="description"> At this early stage, supportive care ofteenough to keep follicles resilient:</Typography>
          <ul>
            <li>Nutrition: </li>
            <ul>
              <li>Biotin — egg yolks, peanuts, almonds, sweet potatoes</li>
              <li>Zinc — chickpeas, cashews, oysters, lentils </li>
              <li>Vitamin D and E — essential for follicle metabolism </li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Stimulation:</li>
            <ul>
              <li> Gentle daily massage with a silicone massager can improve circulatianfollicle health.</li>
            </ul>
          </ul>
          <ul>
            <li>Avoid: Smoking, poor sleep, stress, and harsh chemical treatments.  </li>
          </ul>
          <ul>
            <li>Track Progress: Upload scalp photos every 6–12 months using the app. Thbuilds clear record of density changes over time. </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_legal_stage1 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show</h3>
          </div>
          <Typography className="description">
            Your photos reveal a slight recession of the hairline at the temples, while the crown and mid-scalp remain intact. This corresponds to early androgenetic alopecia, where the first visible changes in the Norwood scale begin to appear. 
          </Typography>
          <Typography className="description mt-10px">
            Stage 2 is often subtle — many patients don’t notice the change themselves until they compare older photos. The density across most of the scalp remains strong, but the temple recession is the first clinical marker of progressive hair loss.
          </Typography>
          <Typography className="description mt-10px">
            Beginning treatment now can stabilize the hairline and restore fullness within 3–6 months.
          </Typography>
        </CardContent>
      </Card>
    ),
    male_why_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens</h3>
          </div>
          <Typography className="description">
            The changes seen at Stage 2 are the result of follicle miniaturization triggered by DHT (dihydrotestosterone). 
          </Typography>
          <ul>
            <li>
              After puberty, testosterone is partially converted to DHT by the enzyme 5-alpha-reductase type I and II.
            </li>
            <li>
              In individuals with genetic sensitivity, DHT binds to receptors in the hair follicles at the temples, where follicles are highly susceptible.
            </li>
            <li>
                The process of miniaturization begins:
              <ul>
                <li>
                  Hairs in these regions emerge finer, shorter, and less pigmented.
                </li>
                <li>
                  The anagen (growth) phase shortens, reducing the time each follicle spends producing hair.
                </li>
                <li>
                  The telogen (resting) phase lengthens, leading to more frequent shedding.
                </li>
              </ul>
            </li>
            <li>
              At Stage 2, only a small proportion of follicles are visibly affected, but the biological process is active and progressing. 
            </li>
            <li>
              If untreated, the temple recession deepens and usually leads into the Stage 3 pattern, where hairline loss becomes pronounced. 
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_what_stage2 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <ul>
          <li>Early intervention is key at this stage. A doctor-prescribed plan can protect vulnerable follicles before large-scale loss occurs.</li>
          <li>Prescription DHT blockers may be advised to stop further miniaturization. </li>
          <li>Peptides and supportive therapies can strengthen existing follicles, increase shaft thickness, and maintain density. </li>
          <li>Lifestyle measures remain important to reduce stress on the follicle environment.</li>
        </ul>
        <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography>
      </>
    ),
    male_timeline_stage2 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1: Hair loss begins to stabilize; shedding may decrease.  
            </li>
            <li>
              Months 3–6: Follicles in the temple region begin producing stronger, thicker hairs. 
            </li>
            <li>
              Months 6–12: Visible restoration of the hairline contour and improved density. 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    male_lifestyle_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
          </div>
          <Typography className="description">At Stage 2, the goal is to support early intervention and protect the hairline:</Typography>
          <ul>
            <li>Nutrition: </li>
            <ul>
              <li>Biotin — egg yolks, peanuts, almonds, sweet potatoes</li>
              <li>Zinc — oysters, chickpeas, cashews, lentils</li>
              <li>Vitamins D and E to protect follicle metabolism</li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Stimulation:</li>
            <ul>
              <li> Daily scalp massage with a silicone massager for 5 minutes can improve circulation.</li>
            </ul>
          </ul>
          <ul>
            <li>Avoid: Smoking, chronic stress, excessive alcohol, and harsh styling techniques.</li>
          </ul>
          <ul>
            <li>Track Progress: Upload scalp photos every 3 months. Early changes are best detected by comparison over time.</li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_legal_stage2 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show</h3>
          </div>
          <Typography className="description">
            Your photos reveal a noticeable recession of the hairline at the temples — a classic sign of androgenetic alopecia (pattern hair loss). This stage often marks the beginning of a predictable progression: the hairline continues to recede, and thinning begins to appear at the crown (vertex). 
          </Typography>
          <Typography className="description mt-10px">
            This is a critical moment. Starting treatment now can help you preserve existing hair, stimulate regrowth, and slow further progression before it becomes more difficult to manage.
          </Typography>
          <Typography className="description mt-10px">
            Men at this stage often regain visible thickness within 3–6 months when treatment is started early.
          </Typography>
        </CardContent>
      </Card>
    ),
    male_why_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens</h3>
          </div>
          <Typography className="description">
            Most male hair loss is caused by a genetic sensitivity to a hormone called dihydrotestosterone (DHT), which is a by-product of testosterone. 
          </Typography>
          <ul>
            <li>After puberty, about 10% of testosterone is naturally converted into DHT by enzymes known as 5-alpha-reductase type I and II.</li>
            <li>
              In men with androgenetic alopecia, DHT binds to receptors in the hair follicles, especially in areas such as the temples and crown.
            </li>
            <li>
              This binding sets off a process known as follicle miniaturization:
              <ul>
                <li>
                  Follicles shrink gradually, producing hairs that are progressively thinner, weaker, and shorter. 
                </li>
                <li>
                  The anagen (growth) phase of the hair cycle shortens, while the telogen (resting) phase lengthens. 
                </li>
                <li>
                  As a result, shedding increases, and regrowth slows. 
                </li>
              </ul>
            </li>
            <li>
              Over time, if this process continues unchecked, some follicles may stop producing hair altogether. 
            </li>
          </ul>
          <Typography className="description">
            This explains why Stage 3 is such an important intervention point: the temples are highly sensitive to DHT, and visible hairline recession is a clear sign that miniaturization is well underway. Acting early can still preserve most of the follicles, restore visible thickness, and prevent progression into more advanced stages.
          </Typography>
        </CardContent>
      </Card>
    ),
    male_what_stage3 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <Typography className="description">
          You should begin a clinically proven, doctor-prescribed DHT-blocking treatment, often combined with targeted peptides. These therapies:
        </Typography>
        <ul>
          <li>Help preserve hair at the temples </li>
          <li>Slow further weakening of follicles </li>
          <li>Improve density and strength of existing hair </li>
        </ul>
        <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography>
        <Typography className="description">
          A licensed doctor will review your case, confirm the stage, and prescribe the most effective treatment plan.
        </Typography>
      </>
    ),
    male_timeline_stage3 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1: Hair loss may stabilize
            </li>
            <li>
              Months 3–6: Visible regrowth often begins 
            </li>
            <li>
              Month 6+: Gradual thickening and stronger density 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    male_lifestyle_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
          </div>
          <Typography className="description"> In addition to medical treatment, your lifestyle plays a key role:</Typography>
          <ul>
            <li>Nutrition:</li>
            <ul>
              <li>Biotin (egg yolks, peanuts, almonds, sweet potatoes)</li>
              <li>Zinc (chickpeas, cashews, lentils, oysters, mussels)</li>
            </ul>
          </ul>
          <ul>
            <li>Scalp Stimulation: Use a silicone scalp massager daily (available on this site). Massage gently for 5 minutes.</li>
          </ul>
          <ul>
            <li>Avoid: Harsh styling tools, hot dryers, smoking. </li>
          </ul>
          <ul>
            <li>
              Track your progress: Use the in-app tracker to log daily care and re-test photos.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_legal_stage3 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show</h3>
          </div>
          <Typography className="description">
            Your photos reveal visible thinning at the crown (vertex) combined with clear recession at the temples. The two regions of loss are distinct but progressively expanding.
          </Typography>
          <Typography className="description mt-10px">
            Stage 4 represents a critical turning point in androgenetic alopecia. At this stage, the hairline continues to recede while thinning at the crown accelerates. Without treatment, these areas usually progress toward merging, leading to extensive baldness in later stages. 
          </Typography>
          <Typography className="description mt-10px">
            Acting now can protect remaining follicles, restore visible density, and prevent progression into advanced stages.
          </Typography>
        </CardContent>
      </Card>
    ),
    male_why_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens</h3>
          </div>
          <Typography className="description">
            The progression of hair loss is primarily caused by genetic sensitivity to dihydrotestosterone (DHT). 
          </Typography>
          <ul>
            <li>
              After puberty, about 10% of testosterone is converted into DHT by enzymes known   as 5-alpha-reductase type I and II. </li>
            <li>
              In genetically predisposed individuals, DHT binds to receptors in the hair follicles, particularly in the crown and temple regions.
            </li>
            <li>
              Over time, this binding leads to miniaturization of the follicles: they shrink gradually, producing finer, weaker, and shorter hairs.
            </li>
            <li>
              The growth phase (anagen) of the hair cycle shortens, while the resting phase (telogen) lengthens. As a result, shedding increases, regrowth slows, and the density of the scalp visibly decreases.
            </li>
            <li>
              At Stage 4, a significant number of follicles are already compromised, and some may have become inactive, unable to produce hair altogether. 
            </li>
          </ul>
          <Typography className="description">
            This is why Stage 4 requires urgent medical treatment — it is the last stage where medical therapy alone can still produce meaningful regrowth for many patients.  
          </Typography>
        </CardContent>
      </Card>
    ),
    male_what_stage4 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <ul>
          <li>A clinically proven, doctor-prescribed DHT blocker is essential at this stage to reduce the action of DHT and slow the progression of hair loss. </li>
          <li>The treatment can be enhanced with specific peptides, which help stimulate follicle activity, improve shaft thickness, and increase density. </li>
          <li>Patients who begin treatment at Stage 4 often experience stabilization of loss and visible improvement in both temple and crown regions. </li>
          <li>Without medical treatment, progression to Stage 5 and beyond is highly likely. </li>
        </ul>
        <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography>
      </>
    ),
    male_timeline_stage4 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1: Hair shedding may begin to stabilize. 
            </li>
            <li>
              Months 3–6: Early regrowth often appears at the crown and temples. 
            </li>
            <li>
              Months 6–12: Clearer improvement in density, thicker regrowth, and stabilization of the hairline. 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    male_lifestyle_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
          </div>
          <Typography className="description"> In addition to prescription treatment, supportive measures are crucial to maximize results: </Typography>
          <ul>
            <li>Nutrition: </li>
            <ul>
              <li>Biotin (egg yolks, almonds, peanuts, sweet potatoes)</li>
              <li> Zinc (oysters, chickpeas, lentils, cashews)</li>
              <li>Vitamins D and E to strengthen follicle resilience</li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Stimulation:</li>
            <ul>
              <li>Daily scalp massage with a silicone massager improves circulation and enhances follicle activity.</li>
            </ul>
          </ul>
          <ul>
            <li>Avoid: Smoking, chronic stress, harsh styling chemicals, and excessive heat from hair dryers. </li>
          </ul>
          <ul>
            <li>Track Progress: Upload scalp photos every 3 months using the app. These will be compared with your baseline results to track your journey visually. </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_legal_stage4 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage5 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show</h3>
          </div>
          <Typography className="description">
            Your photos reveal advanced hair loss with significant temple recession and crown thinning.
          </Typography>
          <Typography className="description mt-10px">
            At this stage, the balding areas are beginning to merge, leaving only a narrow strip of thinning hair separating them.
          </Typography>
          <Typography className="description mt-10px">
            Stage 5 indicates that androgenetic alopecia is progressing rapidly. The central forelock may provide partial coverage but is weak and at risk of being lost without treatment.
          </Typography>
          <Typography className="description mt-10px">
            Immediate treatment is critical. With proper care, responsive follicles can be preserved, though some areas may require transplant for coverage.
          </Typography>
        </CardContent>
      </Card>
    ),
    male_why_stage5 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens</h3>
          </div>
          <Typography className="description">
            The driving force behind your current stage of hair loss is continued exposure of your follicles to dihydrotestosterone (DHT), a by-product of testosterone.
          </Typography>
          <ul>
            <li>
              After puberty, testosterone levels rise, and about 10% of circulating testosterone is converted into DHT by the enzymes 5-alpha-reductase type I and II. </li>
            <li>
              In individuals who are genetically sensitive, DHT binds strongly to specific receptors in the scalp follicles, especially in the temple and crown regions. 
            </li>
            <li>
              This repeated binding sets off a gradual process known as follicle miniaturization: 
              <ul>
                <li>
                  Follicles shrink in size, producing hairs that are progressively thinner,shorter, and weaker. 
                </li>
                <li>
                  The anagen (growth) phase of the hair cycle shortens, while the telogen(resting) phase lengthens. 
                </li>
                <li>
                  As a result, shedding increases, and regrowth slows dramatically.  
                </li>
              </ul>
            </li>
            <li>
              Over time, a growing percentage of follicles become inactive. In these follicles, the biological machinery required to produce new hair shuts down completely, leaving areas of scalp permanently bald.
            </li>
            <li>
              By Stage 5, this process has advanced to the point where the temples and crown thinning regions are beginning to merge, leaving large patches of scalp exposed. The central forelock may remain, but it is weakened and highly vulnerable. 
            </li>
          </ul>
          <Typography className="description">
            This is why Stage 5 is considered advanced androgenetic alopecia: while some follicles can still respond to medical therapy, many are already inactive and may only be restored through surgical options such as transplantation.  
          </Typography>
        </CardContent>
      </Card>
    ),
    male_what_stage5 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <ul>
          <li>Immediate prescription therapy is essential. </li>
          <li>A DHT blocker can still preserve the remaining responsive follicles and slow further progression. </li>
          <li>Peptides can improve the thickness and quality of hair that is still active. </li>
          <li>However, in areas where follicles are already inactive, a hair transplant may be required to restore coverage. </li>
          <li>Patients at Stage 5 benefit most from combining medical treatment with surgical planning for long-term results. </li>
        </ul>
        <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography>
      </>
    ),
    male_timeline_stage5 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1: Noticeable reduction in ongoing shedding. 
            </li>
            <li>
              Months 3–6: Visible regrowth in areas where follicles are still active. 
            </li>
            <li>
              Months 6–12: Significant thickening and reinforcement of surviving hair. 
            </li>
            <li>
              Beyond 12 months: Evaluation for transplantation in non-responsive areas.  
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    male_lifestyle_stage5 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
          </div>
          <Typography className="description"> At this stage, supportive care is especially important to protect and strengthen remaining follicles: </Typography>
          <ul>
            <li>Nutrition: </li>
            <ul>
              <li>Biotin — peanuts, almonds, eggs, sweet potatoes</li>
              <li>Zinc — chickpeas, cashews, lentils, oysters, mussels</li>
              <li>A balanced intake of vitamins A, D, and E</li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Stimulation:</li>
            <ul>
              <li>Use a silicone scalp massager for 5 minutes daily to improve circulation. </li>
            </ul>
          </ul>
          <ul>
            <li>
              Avoid: Smoking, excessive alcohol, hot styling tools, and harsh hair treatments.
            </li>
          </ul>
          <ul>
            <li>Track Progress: Continue using your app’s 3-month photo comparison tool to document improvements and guide treatment adjustments. </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_legal_stage5 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage6 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show</h3>
          </div>
          <Typography className="description">
            Your photos reveal extensive balding across the top of the scalp, with the hairline recession and crown thinning having now fully merged. Only sparse, fragile strands remain through the mid-scalp, and they no longer provide cosmetic coverage. 
          </Typography>
          <Typography className="description mt-10px">
            Stage 6 is classified as severe androgenetic alopecia. At this stage, non-surgical options alone cannot restore natural density. However, medical treatment remains important to preserve donor hair and support transplanted follicles if surgical restoration is pursued. 
          </Typography>
          <Typography className="description mt-10px">
            Surgical restoration is now the most effective option, while medical treatment supports donor health and graft survival.
          </Typography>
        </CardContent>
      </Card>
    ),
    male_why_stage6 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens</h3>
          </div>
          <Typography className="description">
            The biology of hair loss at Stage 6 is driven by the long-term destructive effect of DHT (dihydrotestosterone) on genetically sensitive follicles.  
          </Typography>
          <ul>
            <li>
              From puberty onward, about 10% of testosterone is converted into DHT by the enzymes 5-alpha-reductase type I and II. </li>
            <li>
              In individuals with androgenetic alopecia, DHT binds to receptors in follicles across the crown, mid-scalp, and frontal hairline. 
            </li>
            <li>
              This binding disrupts follicle activity in several ways: 
              <ul>
                <li>
                  The follicle shaft shrinks with each growth cycle (miniaturization).
                </li>
                <li>
                  The anagen (growth) phase shortens, so hairs don’t grow as long or thick. 
                </li>
                <li>
                  The telogen (resting) phase lengthens, leading to increased shedding.
                </li>
                <li>
                  Blood supply and nutrient delivery to the follicle are progressively reduced.
                </li>
              </ul>
            </li>
            <li>
              By Stage 6, the majority of follicles in the affected zones have been dormant for multiple cycles. These follicles are no longer capable of producing hair, even if DHT levels are suppressed.
            </li>
            <li>
              However, the donor zone at the back and sides of the scalp remains resistant to DHT and continues to grow healthy hair. These donor follicles are the foundation for hair transplantation procedures. 
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_what_stage6 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <Typography className="description">
          At Stage 6, the focus shifts from prevention alone to restoration: 
        </Typography>
        <ul>
          <li>
            Hair transplantation (FUE or FUT) is the most effective solution for restoring      visible density. 
            <ul>
              <li>FUE (Follicular Unit Extraction): Individual grafts are extracted from the donor area and implanted into balding zones.</li>
              <li>FUT (Follicular Unit Transplantation): A strip of donor scalp is removed and dissected into grafts for implantation.</li>
            </ul>
          </li>
          <li>
            Prescription DHT blockers may still be prescribed to:
            <ul>
              <li>Protect the remaining donor hair.</li>
              <li>Improve graft survival and long-term outcomes of transplantation.</li>
              <li>Prevent further weakening in partially active follicles.</li>
            </ul>
          </li>
          <li>
            Peptide-based therapies can support follicle strength, enhance scalp quality, and optimize post-transplant recovery. 
          </li>
        </ul>
        <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography>
      </>
    ),
    male_what_to_stage6 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">What to Expect With Treatment </h3>
          </div>
          <ul>
            <li>
              Without surgical intervention: Medical therapy alone cannot restore density at this stage. </li>
            <li>
              With transplantation: 
              <ul>
                <li>
                  Success rates for graft survival exceed 90% when performed by experienced surgeons.
                </li>
                <li>
                  Thousands of grafts are typically required, as restoration must cover the frontal hairline, mid-scalp, and crown. 
                </li>
                <li>
                  Multiple sessions may be recommended, depending on your donor availability and restoration goals.
                </li>
              </ul>
            </li>
            <li>
              After a transplant, ongoing medical treatment remains essential to preserve donor hair and maintain scalp health. 
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_timeline_stage6 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1:  density maintained. 
            </li>
            <li>
              Months 3–6:  No visible changes; subtle improvements in follicle strepossible.
            </li>
            <li>
              Months 6–12: Long-term monitoring ensures that any early changesdetected and treated quickly.
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    male_lifestyle_stage6 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
          </div>
          <Typography className="description">While surgery and prescription therapy are the cornerstones, lifestyle choices remain important to support outcomes: </Typography>
          <ul>
            <li>Nutrition: </li>
            <ul>
              <li> Biotin — egg yolks, almonds, peanuts, sweet potatoes</li>
              <li>Zinc — lentils, cashews, chickpeas, oysters</li>
              <li>Vitamins A, D, and E — help strengthen scalp and follicle environment </li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Stimulation:</li>
            <ul>
              <li>Gentle scalp massage with a silicone massager, 5 minutes daily, improves circulation and aids healing post-transplant.</li>
            </ul>
          </ul>
          <ul>
            <li>Avoid: Smoking, excessive alcohol, chemical styling treatments, and direct trauma to the scalp after surgery. </li>
          </ul>
          <ul>
            <li>Track Progress: Post-transplant regrowth begins at 3–4 months, with major density improvements by 9–12 months. Uploading photos every 3 months through the app ensures accurate tracking. </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_legal_stage6 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage7 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show</h3>
          </div>
          <Typography className="description">
            Your photos reveal end-stage androgenetic alopecia. The entire top of the scalp, including the hairline, mid-scalp, and crown, is bald, with only a narrow horseshoe-shaped band of hair remaining along the back and sides. 
          </Typography>
          <Typography className="description mt-10px">
            This stage represents the final progression of male pattern baldness. Natural density cannot be restored with medical therapy alone, and surgical options may be limited by donor hair availability. 
          </Typography>
          <Typography className="description mt-10px">
            Cosmetic solutions — such as strategic transplantation, scalp micropigmentation, or hair systems — can still provide visible improvement in appearance.
          </Typography>
        </CardContent>
      </Card>
    ),
    male_why_stage7 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens</h3>
          </div>
          <Typography className="description">
            Stage 7 occurs because of the long-term, cumulative impact of DHT (dihydrotestosterone) on genetically sensitive follicles over many years.  
          </Typography>
          <ul>
            <li>From puberty onward, testosterone is partially converted into DHT by 5-alpha-reductase type I and II. </li>
            <li>
              In men with androgenetic alopecia, DHT binds strongly to receptors in follicles across the entire top of the scalp. 
            </li>
            <li>
              This results in repeated miniaturization cycles:
              <ul>
                <li>
                  Hair shafts become progressively thinner and weaker. 
                </li>
                <li>
                  The growth (anagen) phase shortens, so new hairs cannot reach full length or density. 
                </li>
                <li>
                  The resting (telogen) phase dominates, increasing shedding and preventing replacement growth.
                </li>
              </ul>
            </li>
            <li>
              After multiple cycles, a large proportion of follicles become completely inactive, with no capacity to produce new hair. 
            </li>
            <li>
              By Stage 7, the only remaining active follicles are located in the donor zone at the back and sides, which are genetically resistant to DHT. These hairs form the basis for transplantation, but donor supply is often limited compared to the size of the bald area. 
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_what_stage7 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <ul>
          <li>
            Hair transplantation may still be an option, but outcomes are more limited at this stage: 
            <ul>
              <li>
                Coverage across the entire scalp is not possible due to donor shortage.
              </li>
              <li>
                A transplant may be used to reconstruct a natural-looking frontal hairline or small cosmetic zones for partial coverage. 
              </li>
            </ul>
          </li>
          <li>Prescription DHT blockers may be prescribed to protect donor follicles and ensure that any transplanted grafts remain healthy. </li>
          <li>Peptide-based scalp therapies can improve scalp condition and support long-term maintenance of transplanted follicles. </li>
          <li>For some patients, non-surgical solutions (medical-grade hair systems or scalp micropigmentation) may provide the most practical cosmetic improvement. </li>
        </ul>
        <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography>
      </>
    ),
    male_what_to_stage7 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">What to Expect With Treatment </h3>
          </div>
          <ul>
            <li>
              Without surgical or cosmetic intervention: Hair coverage will remain very limited. 
            </li>
            <li>
              With transplantation: 
              <ul>
                <li>
                  A doctor may design a conservative frontal restoration to improve appearance, using limited donor grafts. 
                </li>
                <li>
                  Full coverage is not possible, but strategic placement of grafts can improve framing of the face.
                </li>
              </ul>
            </li>
            <li>
              With non-surgical options: 
              <ul>
                <li>
                  Scalp micropigmentation can simulate the look of a closely shaved scalp. 
                </li>
                <li>
                  Hair systems can provide the appearance of full density where transplantation is not feasible. 
                </li>
              </ul>
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_timeline_stage7 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1:  density maintained. 
            </li>
            <li>
              Months 3–6:  No visible changes; subtle improvements in follicle strepossible.
            </li>
            <li>
              Months 6–12: Long-term monitoring ensures that any early changesdetected and treated quickly.
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    male_lifestyle_stage7 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
          </div>
          <Typography className="description">Even in advanced stages, supporting scalp and donor health is valuable:</Typography>
          <ul>
            <li>Nutrition: </li>
            <ul>
              <li>Biotin — egg yolks, almonds, peanuts, sweet potatoes</li>
              <li>Zinc — oysters, chickpeas, lentils, cashews</li>
              <li>Balanced intake of vitamins A, D, and E to support scalp condition</li>
            </ul>
          </ul>
          <ul>
            <li>Scalp Care:</li>
            <ul>
              <li> 
                Keep the scalp moisturized and healthy to reduce dryness and irritation. 
              </li>
              <li> 
                Gentle massage can maintain circulation and support post-surgical recovery if transplantation is attempted. 
              </li>
            </ul>
          </ul>
          <ul>
            <li>Avoid: Smoking, poor diet, and harsh scalp products that can compromise donor follicle strength. </li>
          </ul>
          <ul>
            <li>Track Progress: Even at Stage 7, continued use of the in-app tracker ensures that scalp condition and any treatment outcomes (transplant, SMP, or systems) are monitored visually. </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_legal_stage7 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    female_photos_description_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show</h3>
          </div>
          <Typography className="description">
            Your photos reveal no visible thinning. Hair appears full and dense, with the central parting remaining narrow and the scalp well covered.
          </Typography>
          <Typography className="description mt-10px">
            Some women take the test at this stage because of increased shedding or a loss of styling volume, even though thinning is not yet visible. These concerns are important, as they may represent the earliest signals of change. 
          </Typography>
          <Typography className="description mt-10px">
            Women at this stage who begin preventive care are more likely to maintain full density and delay the onset of visible thinning.
          </Typography>
        </CardContent>
      </Card>
    ),
    female_why_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens</h3>
          </div>
          <Typography className="description">
            Losing up to 100 hairs per day is normal and should not be a cause for alarm. However, in women with a genetic predisposition, the balance of hormones and follicle sensitivity can gradually change over time. 
          </Typography>
          <ul>
            <li>
              Family history plays an important role. If close female relatives experienced thinning, the risk is higher. </li>
            <li>
              Oestrogen normally protects the follicles. It prolongs the growth phase of the hair cycle and helps maintain density. 
            </li>
            <li>
              After menopause, declining oestrogen levels reduce this protection, and follicles become more vulnerable. 
            </li>
            <li>
              Even though women produce much lower levels of testosterone than men, a small fraction is converted into dihydrotestosterone (DHT).  
            </li>
            <li>
              In sensitive follicles, DHT binds to receptors and begins the process of miniaturisation: hairs grow back finer, the active growth phase shortens, and resting phases lengthen. 
            </li>
            <li>
              Over the years, this cycle can lead to progressive thinning — most often visible along the central parting and crown, which defines the Sinclair pattern of female hair loss. 
            </li>
          </ul>
          <Typography className="description">
            At Stage 1, your hair coverage is still excellent. But understanding these mechanisms explains why early vigilance or preventive treatment is often recommended, especially if there is family history.  
          </Typography>
        </CardContent>
      </Card>
    ),
    female_what_stage1 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <ul>
          <li>Preventive prescription care can help protect follicles before visible thinning begins.</li>
          <li>Monitoring is an option if you prefer to wait — we recommend repeating the test in 6 months. </li>
        </ul>
        <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography>
      </>
    ),
    female_timeline_stage1 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1–2: Shedding may stabilise
            </li>
            <li>
              Month 3–6: Subtle thickening possible 
            </li>
            <li>
              Month 6+: Maintenance of density and delayed onset of thinning 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    female_lifestyle_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
          </div>
          <ul>
            <li>Nutrition: </li>
            <ul>
              <li>Iron (spinach, lentils, red meat) </li>
              <li>Vitamin D + Calcium (oily fish, dairy, eggs) </li>
              <li>
                Biotin & Zinc (almonds, chickpeas, shellfish) 
                Also include fruits, vegetables, and protein-rich foods. 
              </li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Care </li>
            <ul>
              <li>Use sulphate-free shampoo (rosemary or lavender extracts may help).</li>
              <li>Massage the scalp gently with a silicone massager. </li>
              <li>Avoid harsh dyes, frequent bleaching, and heat styling. </li>
            </ul>
          </ul>
          <ul>
            <li> Wellness </li>
            <ul>
              <li>Prioritise sleep and manage stress (yoga, meditation, deep breathing). </li>
              <li>Avoid smoking, which reduces blood flow and accelerates hair loss. </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    female_legal_stage1 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    female_photos_description_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show</h3>
          </div>
          <Typography className="description">
            Your photos reveal mild widening of the central parting, with slightly less density visible compared to Stage 1. Hair remains overall full, but subtle changes in volume may be noticeable when styling. 
          </Typography>
          <Typography className="description mt-10px">
            This corresponds to Stage 2 on the Sinclair scale, often considered the earliest visible stage of female pattern hair loss. Many women first become aware of thinning at this point, particularly when comparing photos or noticing more scalp visibility under bright light. 
          </Typography>
          <Typography className="description mt-10px">
            Women who start medical treatment at Stage 2 often stabilise shedding quickly and preserve visible density long term.
          </Typography>
        </CardContent>
      </Card>
    ),
    female_why_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens</h3>
          </div>
          <Typography className="description">
            At Stage 2, the first visible signs of follicle miniaturisation appear. While daily shedding may still be within the normal range, the regrown hairs are no longer the same as those lost: 
          </Typography>
          <ul>
            <li>Hairs grow back finer and shorter, leading to a gradual reduction in volume.</li>
            <li>
              The central parting begins to widen as miniaturised hairs provide less coverage.
            </li>
            <li>
              After menopause, levels of oestrogen and progestogen naturally decline, while male-type hormones (androgens) may exert more influence. 
            </li>
            <li>
              If your follicles are particularly sensitive to these hormones — especially dihydrotestosterone (DHT) — this can trigger or accelerate hair loss. 
            </li>
          </ul>
          <Typography className="description">
            This stage marks the shift from invisible shedding to visible thinning, making it a crucial moment to begin preventive or corrective measures. 
          </Typography>
        </CardContent>
      </Card>
    ),
    female_what_stage2 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <ul>
          <li>Prescription anti-androgen therapy can block follicle sensitivity to DHT and preserve thickness. </li>
          <li>Topical or oral treatments may stimulate regrowth of miniaturised hairs.</li>
          <li>Regular monitoring with repeat tests every 2 months will help track stability and guide adjustments.</li>
        </ul>
        <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography>
      </>
    ),
    female_timeline_stage2 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1–2: Shedding stabilises 
            </li>
            <li>
              Month 3–6: Visible regrowth and improved density often begin 
            </li>
            <li>
              Months 6–12: Long-term monitoring ensures that any early changesdetected and treated quickly.
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    female_lifestyle_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
          </div>
          <ul>
            <li>Nutrition: </li>
            <ul>
              <li>Iron (spinach, lentils, red meat) </li>
              <li>Vitamin D + Calcium (oily fish, dairy, eggs)  </li>
              <li>
                Biotin & Zinc (almonds, chickpeas, shellfish) 
                Support with fruits, vegetables, and protein-rich foods.
              </li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Care </li>
            <ul>
              <li>Use sulphate-free shampoos; rosemary or lavender extracts may provide mild supportive benefits. </li>
              <li>Massage the scalp daily with a silicone massager to stimulate blood flow. </li>
              <li>Avoid harsh dyes, chemical treatments, or frequent heat styling. </li>
            </ul>
          </ul>
          <ul>
            <li> Wellness </li>
            <ul>
              <li>Prioritise sleep and manage stress with yoga, meditation, or relaxation techniques.</li>
              <li>
                Avoid smoking, which worsens microcirculation and accelerates miniaturisation. 
              </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    female_legal_stage2 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    female_photos_description_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show</h3>
          </div>
          <Typography className="description">
            Your photos reveal a noticeable widening of the central parting, with the scalp more visible compared to Stage 2. Hair density in the frontal and crown regions appears reduced, though overall coverage remains. 
          </Typography>
          <Typography className="description mt-10px">
            This corresponds to Stage 3 on the Sinclair scale, where thinning becomes obvious under normal lighting conditions. Many women at this stage report difficulty maintaining the same hairstyles, reduced volume, and more visible scalp in photos.
          </Typography>
          <Typography className="description mt-10px">
            Women at Stage 3 who start treatment often see significant improvement in density within 6–12 months.
          </Typography>
        </CardContent>
      </Card>
    ),
    female_why_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens</h3>
          </div>
          <Typography className="description">
            At Stage 3, the process of follicle miniaturisation becomes much more visible. 
          </Typography>
          <ul>
            <li>
              The scalp shows clearly through the central parting, and thinning is noticeable in normal lighting. 
            </li>
            <li>
              Miniaturised hairs are thinner and shorter, which reduces their ability to provide volume and coverage.
            </li>
            <li>
              After menopause, the decline in oestrogen and progestogen removes much of the natural protection that previously helped maintain density. 
            </li>
            <li>
              This shift allows androgens, particularly dihydrotestosterone (DHT), to play a more prominent role, further accelerating the miniaturisation process.  
            </li>
            <li>
              The hair cycle becomes imbalanced: the growth phase shortens, while the resting phase lengthens, resulting in continuous shedding without full replacement. 
            </li>
            <li>
              This is a widespread process: over 40% of women experience some form of alopecia after menopause, showing how common and hormonally driven this condition is. 
            </li>
          </ul>
          <Typography className="description">
            At Stage 3, the process is still highly manageable with treatment — but if ignored, progression to more advanced stages becomes likely. 
          </Typography>
        </CardContent>
      </Card>
    ),
    female_what_stage3 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <ul>
          <li>Prescription anti-androgen therapies (oral or topical) can significantly slow or halt progression. </li>
          <li>Combination approaches (medical + supportive care) give the best chance of visible thickening. </li>
          <li>Follow-up testing every 2 months is recommended to track changes and adjust treatment. </li>
        </ul>
        <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography>
      </>
    ),
    female_timeline_stage3 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1–2: Stabilisation of shedding 
            </li>
            <li>
              Month 3–6: New regrowth begins to appear 
            </li>
            <li>
              Month 6–12: Visible thickening, improved volume, and reduction in scalp visibility 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    female_lifestyle_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
          </div>
          <ul>
            <li>Nutrition: </li>
            <ul>
              <li>Iron (spinach, lentils, red meat) </li>
              <li>Vitamin D + Calcium (oily fish, dairy, eggs) </li>
              <li>
                Biotin & Zinc (almonds, chickpeas, shellfish) 
                Support with fruits, vegetables, and protein-based meals.
              </li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Care </li>
            <ul>
              <li>Use sulphate-free shampoos; natural options with rosemary or lavender may support scalp health. </li>
              <li>Perform gentle scalp massage daily to stimulate circulation (unless using prescription topicals). </li>
              <li>Avoid harsh chemical treatments and high-heat styling. </li>
            </ul>
          </ul>
          <ul>
            <li> Wellness </li>
            <ul>
              <li>Ensure adequate sleep and manage stress through yoga, meditation, or relaxation.  </li>
              <li>
                Do not smoke, as it reduces scalp blood flow and accelerates miniaturisation. 
              </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    female_legal_stage3 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    female_photos_description_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show</h3>
          </div>
          <Typography className="description">
            Your photos reveal a marked widening of the central parting, with the scalp clearly visible. Hair in the crown and mid-frontal areas shows reduced density, though lateral and occipital (back) regions remain well preserved. 
          </Typography>
          <Typography className="description mt-10px">
            This corresponds to Stage 4 on the Sinclair scale, where thinning is significant enough to be noticed in casual settings, often causing distress and changes in hairstyle to mask scalp visibility. 
          </Typography>
          <Typography className="description mt-10px">
            Women at Stage 4 who commit to medical treatment often stabilise progression and achieve visible thickening within 6–12 months.
          </Typography>
        </CardContent>
      </Card>
    ),
    female_why_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens</h3>
          </div>
          <Typography className="description">
            By Stage 4, the process of follicle miniaturisation has advanced significantly. 
          </Typography>
          <ul>
            <li>The central parting is markedly widened, and thinning now extends beyond the midline into surrounding areas of the scalp. </li>
            <li>
              Miniaturised hairs dominate, producing strands that are progressively finer, weaker, and less pigmented. 
            </li>
            <li>
              With the continued decline of oestrogen and progestogen, follicles lose their natural hormonal protection, leaving them increasingly vulnerable to androgenic influence.  
            </li>
            <li>
              Even at the lower androgen levels typical in women, DHT is sufficient to drive follicular shrinkage, leading to a progressive reduction in both hair thickness and coverage. 
            </li>
            <li>
              The growth cycle becomes more disrupted: fewer hairs enter the anagen (growth) phase, while more shift into telogen (resting), which accelerates visible loss. 
            </li>
            <li>
              By this stage, the process is part of a well-recognised pattern: more than 40% of women will develop alopecia after menopause, reflecting the loss of hormonal protection and increasing follicular vulnerability.
            </li>
          </ul>
          <Typography className="description">
            At this stage, the loss of volume is substantial, and the scalp is conspicuous in most lighting conditions. Intervention is essential to preserve the remaining density and slow further progression. 
          </Typography>
        </CardContent>
      </Card>
    ),
    female_what_stage4 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <ul>
          <li>Medical treatment is strongly recommended at this stage to preserve remaining active follicles.</li>
          <li>Anti-androgen therapies (oral or topical) help block DHT activity and extend growth phases. </li>
          <li>Combination therapy — prescription + lifestyle measures — offers the best chance of visible recovery. </li>
          <li>Ongoing monitoring with repeat tests every 2 months is essential to track treatment effectiveness. </li>
        </ul>
        <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography>
      </>
    ),
    female_timeline_stage4 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1–2: Stabilisation of shedding 
            </li>
            <li>
              Month 3–6: Thickening of miniaturised hairs 
            </li>
            <li>
              Month 6–12: Visible improvement in scalp coverage and parting density 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    female_lifestyle_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
          </div>
          <ul>
            <li>Nutrition: </li>
            <ul>
              <li>Iron (spinach, lentils, red meat) </li>
              <li>Vitamin D + Calcium (oily fish, dairy, eggs)  </li>
              <li>
                Biotin & Zinc (almonds, chickpeas, shellfish)
                Add fresh fruits, vegetables, and protein for balanced support.
              </li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Care </li>
            <ul>
              <li>
                Use sulphate-free shampoos; rosemary or lavender extracts may be beneficial. 
              </li>
              <li>Gentle daily scalp massage can support circulation. </li>
              <li>Avoid frequent bleaching, dyes, or excessive heat styling. </li>
            </ul>
          </ul>
          <ul>
            <li> Wellness </li>
            <ul>
              <li>Ensure adequate sleep and stress reduction practices (yoga, meditation).  </li>
              <li>Avoid smoking, as it impairs microcirculation and accelerates miniaturisation. </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    female_legal_stage4 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    female_photos_description_stage5 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your Photos Show</h3>
          </div>
          <Typography className="description">
            Your photos reveal severe widening of the central parting, with large areas of scalp visible. The crown and mid-frontal zones are extensively affected, though the back and sides remain relatively preserved. 
          </Typography>
          <Typography className="description mt-10px">
            This corresponds to Stage 5 on the Sinclair scale, where thinning is obvious in all lighting conditions. Many women at this stage experience loss of volume, difficulty styling, and a strong emotional impact due to the visibility of the condition. 
          </Typography>
          <Typography className="description mt-10px">
            Women who begin medical treatment at Stage 5 may still achieve visible thickening, but preserving the remaining follicles is the most urgent goal.
          </Typography>
        </CardContent>
      </Card>
    ),
    female_why_stage5 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why This Happens</h3>
          </div>
          <Typography className="description">
            At Stage 5, the process of miniaturisation has reached an advanced level, and the impact on coverage is significant.
          </Typography>
          <ul>
            <li>The central parting is wide and diffuse, with thinning extending well beyond the midline into larger areas of the scalp. </li>
            <li>
              Miniaturised hairs are now the majority, producing strands that are thin, fragile, and often lack pigmentation. 
            </li>
            <li>
              The continued decline of oestrogen and progestogen after menopause removes almost all protective influence on the follicles. 
            </li>
            <li>
              In this context, even modest levels of androgens (particularly DHT) exert a strong effect, accelerating shrinkage and shortening the growth phase. 
            </li>
            <li>
              The anagen (growth) phase is progressively curtailed, while the telogen (resting) phase dominates, leading to a steady reduction in hair count and quality.
            </li>
            <li>
              By this stage, many follicles enter a prolonged dormancy, and some may cease producing visible hairs altogether. 
            </li>
          </ul>
          <Typography className="description">
            This explains why Stage 5 represents a severe form of female pattern hair loss. The scalp is highly visible in nearly all lighting conditions, and spontaneous recovery is unlikely. Medical intervention is essential at this point to maintain remaining density and prevent further irreversible progression.  
          </Typography>
        </CardContent>
      </Card>
    ),
    female_what_stage5 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What You Can Do</h3>
        </div>
        <ul>
          <li>Immediate medical treatment is strongly advised. Prescription therapies can reduce androgen sensitivity and reactivate dormant follicles. </li>
          <li>Combination therapy (systemic + topical anti-androgens, plus supportive care) offers the best chance of visible improvement. </li>
          <li>Regular monitoring every 2 months is necessary to track progress and adjust treatment.</li>
        </ul>
        <Typography className="description mt-10px">
          Next Steps: Free doctor’s evaluation
        </Typography>
      </>
    ),
    female_timeline_stage5 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1–2: Stabilisation of shedding  
            </li>
            <li>
              Month 3–6: Reactivation of weakened follicles, with early regrowth 
            </li>
            <li>
              Month 6–12: Visible thickening and improved scalp coverage, though full restoration may not be possible 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    female_lifestyle_stage5 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & Daily Care Support</h3>
          </div>
          <ul>
            <li>Nutrition: </li>
            <ul>
              <li>Iron (spinach, lentils, red meat) </li>
              <li>Vitamin D + Calcium (oily fish, dairy, eggs) </li>
              <li>
                Biotin & Zinc (almonds, chickpeas, shellfish) 
                Balanced diet with fruits, vegetables, and protein-rich foods is essential.
              </li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Care </li>
            <ul>
              <li>
                Stick to sulphate-free shampoos, ideally with natural supportive ingredients. 
              </li>
              <li>Gentle scalp massage daily can improve circulation, unless contraindicated by topical therapy. </li>
              <li>Avoid frequent bleaching, dyes, or heavy heat styling. </li>
            </ul>
          </ul>
          <ul>
            <li> Wellness </li>
            <ul>
              <li>Maintain regular sleep cycles and manage stress through meditation or yoga. </li>
              <li>Quit smoking, as it reduces blood flow and accelerates follicle loss. </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    female_legal_stage5 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
  })

  return (
    <>
      {locale && locale === "fr"
        ? masterJsonFr[keyName]
        : locale === "es"
        ? masterJsonEs[keyName]
        : masterJsonEn[keyName]}
    </>
  );
}

export default ReportContentMaster